import React from "react";
import ReactDOM from "react-dom";
import * as Yup from "yup";
import { Multiselect } from "multiselect-react-dropdown";
import _ from "lodash";
import AnchorButton from "../../../components/AnchorButton";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Container from "../../../components/Container";
import DataTable from "../DataTable";
import DropDownList from "../../../components/DropDownList";
import TextBox from "../../../components/TextBox";
import Tooltip from "../../../components/Tooltip";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Flex from "../../../components/Flex";
import FHIRPatient from "../../../components/FHIRPatientRecord";
import Label from "../../../components/Label";
import Layout from "../../../components/Layout";
import handleResponse from "../../../utils/handleFetchResponse";
import fhirBundleParser from "../../../utils/fhirBundleParser";
import { records as fhirToDatatable } from "../../../utils/fhirToDatatable";
import ButtonList from "../../../components/ButtonList";
import LinkButton from "../../../components/LinkButton";
import Button from "../../../components/Button";
import Icon from "../../../components/Icon";
import FHIRSummary from "../../../components/FHIRSummary";
import Loader from "../../../components/Loader";
import Spinner from "../../../components/Loader/Spinner";
import moment from "moment-timezone";
import { useMessageToast } from "../../../components/MessageProvider";
import { useAuthState } from "../../../components/AuthProvider";
import ResultCard from "../../../components/ResultCard";
import createSearchPayload from "../../SearchRecords/Search/createSearchPayload";
import searchOptions from "../../SearchRecords/searchOptions";
import overmergeScoresExtractor from "../../../utils/overmergeScoresExtractor";
import { UseMessage } from "../../../components/MessageProvider";
import { reason_list } from "../../../utils/OvermergeReasons.js";
import { notOvermergeReasons } from "../../../utils/OvermergeReasons.js";
import { overmergeCases } from "../../../utils/OvermergeReasons.js";
import { focusIdFhirBundle } from "../../../utils/fhirBundleParser";
import feedbackApiReqGenerator from "../../../utils/feedbackApiReqGenerator";

import {
  actionCountsHandler,
  identitySpecDataHandler,
  isPreSelectedRowsChanged,
  toggler,
  linkAllToggler
} from "../../../utils/functionUtils.js";
import { checkReadOnlyUser } from "../../../utils/checkReadOnlyUser.js";
import {
  fetchReviewQueueCountData,
  fetchBulkOrgData,
  fetchClientSubscriptionsData
} from "../../../utils/fetchData.js";

import Modal from "../../../components/ModalPopup";
import { useHistory, useParams, Link, useLocation } from "react-router-dom";
import RecordOptions from "./RecordOptions";
import Content from "../../../components/Content";
import ColumnSelector from "./ColumnSelector";
import fetchConfig from "../../../utils/fetchConfig";
import CopyButton from "../../../components/CopyButton";
import CheckBox from "../../../components/CheckBox";
import { formattedDateWithDefault } from "../../../utils/formattedDate";
import { identifiersConfig } from "../../../utils/identifiersConfig";
import TogglingButton from "../../../components/TogglingButton";
import ConfirmationDialog from "./ConfirmationDialog";
import { isImdmClient } from "../../../utils/isImdmClient";
import {
  overrideSummaryForName,
  overrideSummaryForAddress,
  overrideSummaryForIdentifier,
  overrideSummaryForCoverageIdentifierImdm,
  overrideSummaryForGender,
  overrideSummaryForBirthDate,
  overrideSummaryForTelecom,
  overrideSummaryForMultipleBirth
} from "./RecordOverrideUtil";
import { prepareAggregateAuxDataRequest } from "./AggregateAuxUpdate/AggregateAuxUpdateUtil";
import {
  SelectedPrimaryRecords,
  genericOverrideURL,
  birthDateOverrideString,
  genderOverrideString,
  multipleBirthBooleanOverrideString,
  getValueTypeByAttribute,
  overriddenByString,
  overrideReasonString,
  overrideTimestampString,
  dobOverriddenByString,
  dobOverrideReasonString,
  dobOverrideTimestampString,
  genderOverriddenByString,
  genderOverrideReasonString,
  genderOverrideTimestampString,
  multipleBirthOverriddenByString,
  multipleBirthOverrideReasonString,
  multipleBirthOverrideTimestampString
} from "./GoldenRecordExclusion/Utils";
import AttributeValues from "./GoldenRecordExclusion/AttributeValues";
import SummaryTable from "./GoldenRecordExclusion/SummaryTable";
import PrepareOverrides from "./GoldenRecordExclusion/PrepareOverrides";
import ValidationSchema from "./GoldenRecordExclusion/ValidationSchema";
import {
  RecordOverrideCountString,
  AttributeDropDownValues,
  ActionDropDownValues,
  IdentifierSystemDropDownValues,
  IdentifierCodeDropDownValues,
  AttrCodeDropDownValues,
  CorrectAndIncorrectDropDownValues
} from "./GoldenRecordExclusion/ComponentValues";
import ConfirmMultipleAttributeOverrideModal from "./MultipleAttributeOverride/Modal/ConfirmMultipleAttributeOverrideModal";
import MultipleAttributeOverrideModal from "./MultipleAttributeOverride/Modal/MultipleAttributeOverrideModal";
import { defaultAttributeOverridesObject } from "./MultipleAttributeOverride/Utils";
import OverrideAuditInputModal from "./OverrideAuditInputModal";
import { createOverrideAuditExtension } from "./MultipleAttributeOverride/PrepareOverrides";
import styles from "./RecordTable.module.scss";
import { capitalize } from "../../../utils/textFunctions";
import { v4 as uuidv4 } from "uuid";
import FloatingSummaryButton from "./FloatingSummaryButton.js";

const SearchRecordTable = ({
  rq_gid = "",
  rq_aggregate,
  is_review_queue_page = false,
  skipReviewedHandler,
  rq_clientId,
  rqFhirBundleData
}) => {
  const history = useHistory();
  const { user } = useAuthState();
  const [hiddenColumns, setHiddenColumns] = React.useState(["mrn", "ssn"]);
  const [primaryRecords, setPrimaryRecords] = React.useState([]);
  const [primaryRecordsFiltered, setPrimaryRecordsFiltered] = React.useState(
    []
  );
  const [expandedPrimaryRecords, setExpandedPrimaryRecords] = React.useState(
    []
  );
  const [
    expandedSecondaryRecords,
    setExpandedSecondaryRecords
  ] = React.useState([]);
  const [quarantineRecords, setQuarantineRecords] = React.useState([]);
  const [recordIDToFhirMap, setRecordIDToFhirMap] = React.useState([]);
  const toast = useMessageToast();
  const {
    selectedClient: { id: clientIdNumber }
  } = user.preferences;

  const userId = user.username;
  const type = user.rq_type;

  const [rowPopOverVisible, setRowPopoverVisible] = React.useState(false);
  const [selectedRecord, setSelectedRecord] = React.useState("");
  const [selectedRowsMap, setSelectedRowsMap] = React.useState(new Map());
  const scoreRef = React.useRef([]);
  const focusedIdFhirBundleRef = React.useRef(null);

  const [preSelectedRowsMap, setPreSelectedRowsMap] = React.useState(new Map());
  const [
    otherRelatedIdentitySpecMap,
    setOtherRelatedIdentitySpecMap
  ] = React.useState(new Map());
  const [
    mergeIdentitySpecEnableDisableMap,
    setMergeIdentitySpecEnableDisableMap
  ] = React.useState(new Map());
  const [primarySpecId, setPrimarySpecId] = React.useState("");
  const [actionCounts, setActionCounts] = React.useState({
    includeToPrimary: 0,
    excludeFromPrimary: 0,
    selectedPrimaryRecords: 0
  });
  const [confirmationDailog, setConfirmationDialog] = React.useState(false);
  const [compareRecordsDialog, setCompareRecordsDialog] = React.useState(false);
  const [recordOverrideDialog, setRecordOverrideDialog] = React.useState(false);
  const [
    recordOverrideSummaryDialog,
    setRecordOverrideSummaryDialog
  ] = React.useState(false);
  const [recordOverridePayload, setRecordOverridePayload] = React.useState({});
  const [
    recordOverrideRestoreList,
    setRecordOverrideRestoreList
  ] = React.useState([]);
  const [
    recordOverrideRestoreIndexList,
    setRecordOverrideRestoreIndexList
  ] = React.useState([]);
  const [
    recordOverrideDialogContent,
    setRecordOverrideDialogContent
  ] = React.useState({});
  const [attributeOverrides, setAttributeOverrides] = React.useState(
    defaultAttributeOverridesObject
  );
  const [recordOverride, setRecordOverride] = React.useState({});
  const [aggregateLoadingState, setAggregateLoadingState] = React.useState(
    false
  );
  const [recordListLoadingState, setRecordListLoadingState] = React.useState(
    false
  );
  const [
    aggregateEimpLastUpdated,
    setAggregateEimpLastUpdated
  ] = React.useState();
  const [identity, setIdentity] = React.useState(null);
  const { selectedClient } = user.preferences;
  const isImdm = isImdmClient(selectedClient);

  let {
    ms_gid,
    rqType,
    assignedRQId,
    OverlayType,
    quar_recordId,
    quar_sourceId
  } = useParams();
  quar_recordId = decodeURIComponent(quar_recordId);
  quar_sourceId = decodeURIComponent(quar_sourceId);

  const [isIdSpecPerformed, setIsIdSpecPerformed] = React.useState(false);
  const [goldenId, setGoldenId] = React.useState(
    !is_review_queue_page ? ms_gid : rq_gid
  );
  const [action, setAction] = React.useState();

  const [
    deleteConfirmationDailog,
    setDeleteConfirmationDialog
  ] = React.useState(false);
  const [selectedDeleteRecord, setSelectedDeleteRecord] = React.useState("");
  const setSelectedRecordHandler = item => {
    setSelectedDeleteRecord(item);
    setDeleteConfirmationDialog(true);
  };
  const [
    multipleAttributeOverrideDialog,
    setMultipleAttributeOverrideDialog
  ] = React.useState(false);
  const [
    confirmMultipleAttributeOverrideDialog,
    setConfirmMultipleAttributeOverrideDialog
  ] = React.useState(false);
  const [
    selectedMultipleAttributeOverrideRecord,
    setSelectedMultipleAttributeOverrideRecord
  ] = React.useState("");
  const setSelectedMultipleAttributeOverrideHandler = record => {
    setSelectedMultipleAttributeOverrideRecord(record);
    setMultipleAttributeOverrideDialog(true);
  };
  const [isAuditModalOpen, setIsAuditModalOpen] = React.useState(false);
  const [pendingOverrideForm, setPendingOverrideForm] = React.useState(null);
  const [pendingOverrideValues, setPendingOverrideValues] = React.useState(
    null
  );
  const [auditModalContext, setAuditModalContext] = React.useState(null); // "multi" or "single"

  const [recordHistoryList, setRecordHistoryList] = React.useState(new Map());
  const [recordComparisonList, setRecordComparisonList] = React.useState(
    new Map()
  );
  const [showScores, setShowScores] = React.useState(false);
  const [showRelatedIdsScores, setShowRelatedIdsScores] = React.useState(false);
  const [showOptions, setShowOptions] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [valueStrings, setValueStrings] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [overmergeMessage, setOvermergeMessage] = React.useState("");
  const [isOvermergeByApi, setIsOvermergeByApi] = React.useState(null);

  const [columnOrder, setColumnOrder] = React.useState([]);
  const [threshold, setThreshold] = React.useState("-");
  const [secondaryRecords, setSecondaryRecords] = React.useState([]);
  const [isLinkAllSelected, setIsLinkAllSelected] = React.useState(false);

  const [
    primarySelectAllCheckBox,
    setPrimarySelectAllCheckBox
  ] = React.useState(false);
  const [
    secoundrySelectAllCheckBox,
    setSecoundrySelectAllCheckBox
  ] = React.useState(false);
  const [
    mergeIdspecsConfirmationDialog,
    setMergeIdspecsConfirmationDialog
  ] = React.useState(false);
  const [mergeRelatedIdentity, setMergeRelatedIdentity] = React.useState("");

  const location = useLocation();
  const { preLoadedSearchCriteria } = location.state || {
    preLoadedSearchCriteria: [
      {
        key: "",
        label: "",
        value: ""
      }
    ]
  };

  const [isQuarantineView, setIsQuarantineView] = React.useState(false);

  const [nameToTypeMap, setNameToTypeMap] = React.useState({});

  const [isNewQuarantine, setIsNewQuarantine] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [quarantineDemographics, setQuarantineDemographics] = React.useState(
    null
  );
  const [
    currentQuarantineDemographics,
    setCurrentQuarantineDemographics
  ] = React.useState(null);
  const [attributeValues, setAttributeValues] = React.useState([]);
  const [scoreStringDialog, setScoreStringDialog] = React.useState(false);
  const [scoreString, setScoreString] = React.useState("");

  const [highlightGiven, setHighlightGiven] = React.useState(false);
  const [highlightDOB, setHighlightDOB] = React.useState(false);
  const [highlightSSN, setHighlightSSN] = React.useState(false);
  const [highlightMBI, setHighlightMBI] = React.useState(false);

  const COLORS = [
    "#e6f9d5",
    "#fff9c4",
    "#bbdefb",
    "#ffe0b2",
    "#f8bbd0",
    "#e1bee7",
    "#b2ebf2",
    "#f0f4c3",
    "#cfd8dc",
    "#d7ccc8"
  ];
  const [highlightAll, setHighlightAll] = React.useState(false);

  function getValueColorMap(records, accessor) {
    const valueSet = new Set();
    records.forEach(r => {
      let value = typeof accessor === "function" ? accessor(r) : r[accessor];
      if (value && value !== "-") valueSet.add(value);
    });
    const values = Array.from(valueSet);
    const colorMap = {};
    values.forEach((v, i) => {
      colorMap[v] = COLORS[i % COLORS.length];
    });
    if (values.length > COLORS.length) {
      console.warn(
        "More unique values than available colors. Colors will repeat."
      );
    }
    return colorMap;
  }

  const givenNameColorMap = getValueColorMap(
    primaryRecords,
    r => r.givenName || "-"
  );
  const dobColorMap = getValueColorMap(primaryRecords, "birthDate");

  const dobDistinctValues = Object.keys(dobColorMap);
  const firstDOB = dobDistinctValues.length > 0 ? dobDistinctValues[0] : null;

  const ssnColorMap = getValueColorMap(primaryRecords, "ssn");
  const mbiColorMap = getValueColorMap(primaryRecords, "mbi");

  // const contructSearchCriteriaForRecordListpage  = () =>{
  //   const searchCriteriaWithHCMId = [...preLoadedSearchCriteria,{
  //     "key": "golden_id",
  //     "label": "HCM ID",
  //     "value": ms_gid
  // }];

  //   console.log("preLoadedSearchCriteria "+JSON.stringify(searchCriteriaWithHCMId))
  //   return searchCriteriaWithHCMId;
  // }

  const [searchCriteria, setSearchCriteria] = React.useState(
    preLoadedSearchCriteria
  );
  const [isIdPresentInDynamicRQ, setIsIdPresentInDynamicRQ] = React.useState(
    false
  );
  const [dynamicRQofId, setDynamicRQofId] = React.useState({
    NearMissReviewQueue: false,
    IMDMNearMatchReviewQueue: false,
    TwinsReviewQueue: false,
    CollisionDetectionReviewQueue: false
  });
  const [reviewConfirmDialog, setReviewConfirmDialog] = React.useState(false);

  const [assignedRQList, setAssignedRQList] = React.useState([]);
  const [assignRQDialog, setAssignRQDialog] = React.useState(false);
  const [toBeAssignedRQList, setToBeAssignedRQList] = React.useState([]);
  const [reviewLoading, setReviewLoading] = React.useState(false);
  const [
    alreadyAssignedRQOfFocusIdList,
    setAlreadyAssignedRQOfFocusIdList
  ] = React.useState([]);

  const [destinationGID, setDestinationGID] = React.useState("");
  const [forceMergeDialog, setForceMergeDialog] = React.useState(false);
  const [
    multipleRecordOverrideDialog,
    setMultipleRecordOverrideDialog
  ] = React.useState(false);

  const [
    isRelatedIdentitesSearch,
    setIsRelatedIdentitesSearch
  ] = React.useState(false);

  const [linkageHistory, setLinkageHistory] = React.useState([]);

  const sourcesMap = user.preferences.sources;
  //Tooltip displayed with "Actions" column header
  const toolTipContent = (
    <div>
      <p>
        <Icon type="add" className={styles.tooltipIcon} /> <b>Include</b> record
        <b> to</b>
      </p>
      <p style={{ marginBottom: "1rem" }}> IdentitySpec</p>
      <p>
        <Icon type="subtract" className={styles.tooltipIcon} /> <b>Exclude</b>{" "}
        record
        <b> from</b>
      </p>
      <p>IdentitySpec</p>
    </div>
  );
  const [showRestrictedDialog, setshowRestrictedDialog] = React.useState(false);
  const [RestrictedEids, setRestrictedEids] = React.useState([]);
  const [isRestricted, setisRestricted] = React.useState(false);
  const [matchApiResponse, setMatchApiResponse] = React.useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = React.useState(false);

  const RepartitionModal = () => {
    const handlePreviewRepartition = async () => {
      console.log("Preview button clicked");
      setAggregateLoadingState(true);
      const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/stewardship/repartition/${goldenId}`;
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            clientId: selectedClient.oid,
            "Content-Type": "application/json",
            userId: userId,
            preview: true
          }
        });
        const data = await response.json();

        // Store the after-repartition response
        localStorage.setItem("afterRepartitionData", JSON.stringify(data));

        // Store the before-repartition response (from your last match/search API call)
        // Make sure matchApiResponse is up-to-date before this!
        localStorage.setItem(
          "beforeRepartitionData",
          JSON.stringify(matchApiResponse)
        );

        setAggregateLoadingState(false);
        setIsPreviewLoading(false);

        // Open the preview tab
        const compareTabUrl = `/repartition-preview`;
        const newTab = window.open(compareTabUrl, "_blank");
        if (!newTab) {
          toast.error(
            "Failed to open a new tab. Please allow pop-ups in your browser."
          );
        }
        setIsRepartitionModalOpen(false);
      } catch (error) {
        setAggregateLoadingState(false);
        setIsPreviewLoading(false);
        toast.error("Failed to fetch preview data.");
      }
    };

    const handleRepartitionSubmit = goldenId => {
      setAggregateLoadingState(true);
      const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/stewardship/repartition/${goldenId}`;
      fetch(url, {
        method: "POST",
        headers: {
          clientId: selectedClient.oid,
          "Content-Type": "application/json",
          userId: userId
        }
      })
        .then(handleResponse)
        .then(() => {
          fetchFhirBundle();

          setAggregateLoadingState(false);
          fetchLinkageHistory();
          fetchAggregate();
          toast.info(`Identity successfully repartitioned.`);
          setIsRepartitionModalOpen(false);
        })
        .catch(error => {
          setAggregateLoadingState(false);
          toast.error(`Failed to repartition identity.`);
          setIsRepartitionModalOpen(false);
        });
    };

    return (
      <Modal
        open={isRepartitionModalOpen}
        onClose={() => setIsRepartitionModalOpen(false)}
      >
        <div style={{ padding: "20px", position: "relative" }}>
          <button
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "none",
              border: "none",
              fontSize: "16px",
              cursor: "pointer"
            }}
            onClick={() => setIsRepartitionModalOpen(false)}
            aria-label="Close"
          >
            ✖
          </button>
          <h2>Repartition Confirmation</h2>
          <p>
            Would you like to preview the changes or submit the repartition?
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px"
            }}
          >
            <Button
              onClick={() => handlePreviewRepartition()}
              disabled={isPreviewLoading} // Disable button while loading
            >
              {isPreviewLoading ? <Spinner size="small" /> : "Preview"}
            </Button>
            <Button primary onClick={() => handleRepartitionSubmit(goldenId)}>
              Submit
            </Button>
          </div>
        </div>
      </Modal>
    );
  };

  React.useEffect(() => {
    setAggregateLoadingState(true);
    const checkIsQuarantineView = location.pathname.includes("quarantine");
    setIsQuarantineView(checkIsQuarantineView);

    const fetchQuarantine = async () => {
      let url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/quarantine/idspecQuarantinedRecord`;
      url =
        url +
        "?sourceEntityId=" +
        quar_recordId +
        "&sourceSystemId=" +
        quar_sourceId +
        "&severity=hard";
      const mockUrl = `/QuarantineRecord.json`;
      const config = {
        headers: {
          clientId: selectedClient.oid,
          userId: userId
        }
      };
      fetch(...fetchConfig(url, mockUrl, config))
        .then(handleResponse)
        .then(response => {
          if (response.data.currentRecord) {
            setGoldenId(response.data.currentRecord.goldenId);
            setCurrentQuarantineDemographics(
              response.data.currentRecord.demographics
            );
            setIsNewQuarantine(false);
          } else {
            setGoldenId("");
            setIsNewQuarantine(true);
          }
          let quarantineRecord = JSON.parse(
            response.data.quarantineRecord.demographics
          );
          quarantineRecord.lastUpdatedTime =
            response.data.quarantineRecord.lastUpdatedTime;
          quarantineRecord.classification =
            response.data.quarantineRecord.classification;
          setQuarantineDemographics(quarantineRecord);
          setAggregateLoadingState(false);
        })
        .catch(e => {
          console.error("fetchAggregate error; ", e);
          setAggregateLoadingState(false);
          setLoading(false);
          toast.error("Quarantine record not found");
          history.push("/review-queue-dashboard");
        });
    };
    const fetchQuarantineTypes = async () => {
      let result = {};
      const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/quarantine_type/`;
      const mockUrl = `/quarantineTypes.json`;
      const config = {
        method: "GET"
      };
      await fetch(...fetchConfig(url, mockUrl, config))
        .then(handleResponse)
        .then(response => {
          if (response.results && response.results.length > 0) {
            const typeDescriptionMap = [];
            const results = response.results;

            for (const result of results) {
              let name = result.name;
              let sourceSpecificName = result.source_specific_name || "";
              let description = result.description || "";

              if (typeDescriptionMap[name]) {
                continue;
              }

              typeDescriptionMap[name] = {
                type: sourceSpecificName,
                description: description
              };
            }

            setNameToTypeMap(typeDescriptionMap);
          }
        })
        .catch(e => {
          console.error("fetchQuarantineTypes error; ", e);
          toast.error("Failed to fetch quarantine types");
        });
    };
    fetchQuarantineTypes();
    if (checkIsQuarantineView) {
      fetchQuarantine();
    } else {
      setIsNewQuarantine(false);
    }
    setLoading(false);
    setAggregateLoadingState(false);
  }, [location.pathname]);

  React.useEffect(() => {
    if (primaryRecords.length > 0 && isQuarantineView) {
      const row = primaryRecords.find(
        item => item.recordId === quar_recordId && item.source === quar_sourceId
      );
      if (row !== undefined) {
        expandDetails(row, true);
      }
    }
  }, [primaryRecordsFiltered]);

  React.useEffect(() => {
    if (isNewQuarantine) {
      fhirBundleDataExtractor([]);
    }
  }, [isNewQuarantine]);

  // when replace override calls
  React.useEffect(() => {
    if (
      (recordOverrideDialogContent["Mark as"] === "Replace" ||
        recordOverrideDialogContent["Mark as"] === "New") &&
      !recordOverrideDialogContent.overrideIconClicked
    )
      handleConfirmOverride([]);
    if (recordOverrideDialogContent.reviewOverrideType === "all")
      setRecordOverridePayload(prepareOverrideRequest(true));
  }, [recordOverride, recordOverrideDialogContent]);

  // when override summery  calls
  React.useEffect(() => {
    if (recordOverrideDialogContent.reviewOverrideType === "all")
      setRecordOverrideSummaryDialog(true);
  }, [recordOverridePayload]);

  //Fetching aggregate from goldenId
  const fetchAggregate = React.useCallback(() => {
    setAggregateLoadingState(true);
    if (goldenId !== "") {
      const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/aggregate/${goldenId}`;
      const mockUrl = `/getIdentityDetails.json`;
      const config = {
        headers: {
          clientId: selectedClient.oid,
          "Content-Type": "application/json",
          userId: userId
        }
      };
      fetch(...fetchConfig(url, mockUrl, config))
        .then(handleResponse)
        .then(response => {
          setIdentity(response.data);
          setAggregateLoadingState(false);
        })
        .catch(e => {
          console.error("fetchAggregate error; ", e);
          setAggregateLoadingState(false);
          toast.error("Something went wrong while fetching the records");
        });
    }
  }, [toast, goldenId, selectedClient.oid]);

  // search bar
  //
  const formRecordIDSourceIdCombinationMatcherSearchPayload = () => {
    const recordIdSourceCombinationSearchPayload = {};
    recordIdSourceCombinationSearchPayload.patient = {};
    recordIdSourceCombinationSearchPayload.patient.resourceType = "Patient";
    recordIdSourceCombinationSearchPayload.patient.meta = {};
    recordIdSourceCombinationSearchPayload.patient.meta.source =
      primaryRecords[1].source;

    recordIdSourceCombinationSearchPayload.patient.identifier = [
      {
        value: primaryRecords[1].sourceEntityId
      }
    ];
    return recordIdSourceCombinationSearchPayload;
  };

  const mergeIdspecConfirmationModal = () => {
    return (
      <Modal
        open={mergeIdspecsConfirmationDialog}
        onClose={() => setMergeIdspecsConfirmationDialog(false)}
      >
        <div>
          <div>
            <p>Are you sure you would like to Merge with Focus IdentitySpec</p>
            <br />
            <p>These changes will be reflected in the Focus Identity </p>
            <p>record partitioning.</p>
          </div>
          <br />
          <ButtonList className={styles.center}>
            <Button
              type="submit"
              primary
              onClick={() => {
                handleMergeIdentitySpec();
              }}
            >
              Confirm
            </Button>
            <Button onClick={() => setMergeIdspecsConfirmationDialog(false)}>
              Cancel
            </Button>
          </ButtonList>
        </div>
      </Modal>
    );
  };

  const handleMergeIdentitySpec = () => {
    setMergeIdspecsConfirmationDialog(false);

    let customOject = {
      user,
      primarySpecId,
      clientId: selectedClient.oid
    };

    const payload = identitySpecDataHandler(
      preSelectedRowsMap,
      customOject,
      "Merge",
      "",
      ""
    );
    const includes = [...payload.identitySpec.include];
    let excludes = [...payload.identitySpec.exclude];
    console.log("otherRelatedIdentitySpecMap -->", otherRelatedIdentitySpecMap);
    otherRelatedIdentitySpecMap &&
      otherRelatedIdentitySpecMap.every(value => {
        if (value.aggregates && value.aggregates.has(mergeRelatedIdentity)) {
          value.records.forEach(item => {
            if (item.operation === "include") {
              includes.push({
                sourceSystemId: item.sourceId,
                entityId: item.recordId
              });
            } else if (item.operation === "exclude") {
              excludes.push({
                sourceSystemId: item.sourceId,
                entityId: item.recordId
              });
            }
          });
          return false;
        }
        return true;
      });

    //Removing elements for excludes if already there in includes
    excludes = excludes.filter(
      el =>
        !includes.find(
          rm =>
            rm.sourceSystemId === el.sourceSystemId &&
            rm.entityId === el.entityId
        )
    );
    payload.identitySpec.include = includes;
    payload.identitySpec.exclude = excludes;
    console.log("payload -->", payload);

    setRecordListLoadingState(true);
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/stewardship/identityspec`;
    const mockUrl = `/fetchReviewQueue1.json`;
    const config = {
      method: "PUT",
      body: JSON.stringify(payload),
      credentials: "include",
      headers: {
        clientId: selectedClient.oid,
        "Content-Type": "application/json",
        userId: userId
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(async () => {
        setPrimarySpecId("");
        setPreSelectedRowsMap(new Map());
        await fetchFhirBundle(false, true, true);
        //await fetchFhirBundle(true);
        setRecordListLoadingState(false);
        setIsLinkAllSelected(false);
        await fetchLinkageHistory();
        await fetchAggregate();
        toast.success(`Merge Idspec operation was successful`);
      })
      .catch(error => {
        console.error("Merge Idspecr error: ", error);
        setRecordListLoadingState(false);
        toast.error(`Merge Idspecoperation failed`);
      });
  };

  //Fetching Identity Spec
  const bulkStewardHandler = ({
    action,
    reason,
    comments,
    isSkipRepartitionRequest = false
  }) => {
    setConfirmationDialog(false);
    let customOject = !isSkipRepartitionRequest
      ? {
          user,
          primarySpecId,
          clientId: selectedClient.oid
        }
      : {
          targetGID: goldenId,
          user,
          primarySpecId,
          clientId: selectedClient.oid
        };
    const payload = identitySpecDataHandler(
      selectedRowsMap,
      customOject,
      action,
      reason,
      comments
    );
    setRecordListLoadingState(true);
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/stewardship/identityspec`;
    const mockUrl = `/fetchReviewQueue1.json`;
    const config = {
      method: "PUT",
      body: JSON.stringify(payload),
      credentials: "include",
      headers: {
        clientId: selectedClient.oid,
        "Content-Type": "application/json",
        userId: userId
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(async () => {
        setPrimarySpecId("");
        setPreSelectedRowsMap(new Map());
        await fetchFhirBundle(false, true, true);

        setRecordListLoadingState(false);
        setIsLinkAllSelected(false);

        await fetchLinkageHistory();
        await fetchAggregate();
        toast.success(`Link/Unlink operation was successful`);
      })
      .catch(error => {
        console.error("bulkStewardHandler error: ", error);
        setRecordListLoadingState(false);
        toast.error(`Link/Unlink operation failed`);
      });
  };

  const identitySpecHandler = React.useCallback(
    async (allRecords, primarySpecId) => {
      if (primarySpecId && !isNewQuarantine) {
        const clonedMap = new Map(selectedRowsMap);
        const otherIdSpecMap = new Map();
        const mergeButtonIdspecMap = new Map(mergeIdentitySpecEnableDisableMap);
        for (let record of allRecords) {
          if (record.identitySpecID === primarySpecId) {
            clonedMap.set(record.id + "+" + record.meta.source, {
              operation: "include",
              table: "primary",
              identitySpecID: primarySpecId
            });
          }
          if (record.excludedBy && record.excludedBy.includes(primarySpecId)) {
            clonedMap.set(record.id + "+" + record.meta.source, {
              operation: "exclude",
              identitySpecID: primarySpecId
            });
          }
          constructOtherRelatedIdSpecMap(
            otherIdSpecMap,
            mergeButtonIdspecMap,
            record,
            primarySpecId
          );
        }
        setActionCounts(actionCountsHandler(clonedMap));
        //??
        setSelectedRowsMap(clonedMap);
        const copyMap = new Map(clonedMap);
        setSelectedRowsMap(copyMap);
        setPreSelectedRowsMap(copyMap);
        setOtherRelatedIdentitySpecMap(otherIdSpecMap);
        setMergeIdentitySpecEnableDisableMap(mergeButtonIdspecMap);
      }
    },
    [selectedRowsMap]
  );

  const constructOtherRelatedIdSpecMap = (
    otherIdSpecMap,
    mergeButtonIdspecMap,
    record,
    primarySpecId
  ) => {
    let recordList = [];
    let aggregateList = new Set();
    const specIdList = [];
    if (record.identitySpecID && record.identitySpecID !== primarySpecId) {
      const specArray = record.identitySpecID.split("|");
      specArray.forEach(id => {
        specIdList.push({ identitySpecID: id });
      });
    }
    if (record.excludedBy && !record.excludedBy.includes(primarySpecId)) {
      const specArray = record.excludedBy.split("|");
      specArray.forEach(id => {
        specIdList.push({ excludedBy: id });
      });
    }
    specIdList.forEach(idspecOperation => {
      const specId =
        idspecOperation.identitySpecID || idspecOperation.excludedBy;
      const aggregateId =
        record.link &&
        record.link[0] &&
        record.link[0].other &&
        record.link[0].other.reference;
      if (!aggregateId) {
        return;
      }
      const item = {
        operation: idspecOperation.identitySpecID ? "include" : "exclude",
        recordId: record.id,
        sourceId: record.meta.source,
        table:
          (idspecOperation.identitySpecID &&
            idspecOperation.identitySpecID === primarySpecId) ||
          (idspecOperation.excludedBy &&
            idspecOperation.excludedBy.includes(primarySpecId))
            ? "primary"
            : "secoundry"
      };
      if (specId && otherIdSpecMap.has(specId)) {
        recordList = [...otherIdSpecMap.get(specId).records];
        aggregateList = otherIdSpecMap.get(specId).aggregates;
      }
      recordList.push(item);
      if (idspecOperation.identitySpecID) {
        aggregateList.add(aggregateId);
      }
      otherIdSpecMap.set(specId, {
        records: recordList,
        aggregates: aggregateList,
        enableMergeButton: true
      });
      if (
        idspecOperation.identitySpecID &&
        !mergeButtonIdspecMap.has(aggregateId)
      ) {
        mergeButtonIdspecMap.set(aggregateId, new Set());
      }
    });
  };

  const constructSearchRelatedIdentitiesData = async data => {
    let secondaryRecordList = fhirToDatatable(
      data.map(value => {
        value.table = "secondary";
        return value;
      }),
      sourcesMap,
      nameToTypeMap
    );
    let allRecordWithSource = secondaryRecordList
      .filter(record => !record.actions)
      .map(record => {
        return {
          sourceEntityId: record.sourceEntityId,
          sourceSystemId: record.source
        };
      });
    const overlayStatusByRecordIdsResponse = await fetchOverlayStatusByRecordIds(
      allRecordWithSource
    );

    if (
      overlayStatusByRecordIdsResponse &&
      Object.keys(overlayStatusByRecordIdsResponse).length > 0
    ) {
      secondaryRecordList = secondaryRecordList.map(record => {
        if (overlayStatusByRecordIdsResponse.hasOwnProperty(record.id)) {
          record.overlayStatus =
            overlayStatusByRecordIdsResponse[record.id] !== "Reviewed";
        }
        return record;
      });
    }
    const overlayStatusByQuarantineRecordIdsResponse = await fetchOverlayStatusByQuarantineRecordIds(
      allRecordWithSource
    );
    if (
      overlayStatusByQuarantineRecordIdsResponse &&
      Object.keys(overlayStatusByQuarantineRecordIdsResponse).length > 0
    ) {
      secondaryRecordList = secondaryRecordList.map(record => {
        if (
          overlayStatusByQuarantineRecordIdsResponse.hasOwnProperty(record.id)
        ) {
          record.quarantineOverlayStatus =
            overlayStatusByQuarantineRecordIdsResponse[record.id] ===
            "ProblematicOverlay";
        }
        return record;
      });
    }

    primaryRecords.map(primaryRecord => {
      secondaryRecordList = secondaryRecordList.filter(
        record => record.sourceEntityId !== primaryRecord.sourceEntityId
      );
    });

    const expandedSecoundryRecords = extractExpandedSecondaryRecords(data);
    const preSlectedMap = new Map(preSelectedRowsMap);
    setSelectedRowsMap(preSlectedMap);
    const otherIdSpecMap = new Map();
    const mergeButtonIdspecMap = new Map(mergeIdentitySpecEnableDisableMap);
    for (let record of expandedSecoundryRecords) {
      constructOtherRelatedIdSpecMap(
        otherIdSpecMap,
        mergeButtonIdspecMap,
        record,
        primarySpecId
      );
    }
    setOtherRelatedIdentitySpecMap(otherIdSpecMap);
    setMergeIdentitySpecEnableDisableMap(mergeButtonIdspecMap);
    setSecondaryRecords(secondaryRecordList);
    setExpandedSecondaryRecords(expandedSecoundryRecords);
  };

  const fetchOverlayStatusByRecordIds = async reqBody => {
    let result = {};
    const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/rpc/overlayReviewQueueItems/update/?overlay_status_by_ids=true&client_id=${selectedClient.oid}`;
    const mockUrl = `/OverlayStatusByRecords.json`;
    const config = {
      method: "PUT",
      body: JSON.stringify({ records: reqBody }),
      headers: {
        "Content-Type": "application/json"
      }
    };
    await fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        if (response.records && response.records.length > 0) {
          response.records.forEach(rec => {
            result[rec.source_entity_id + "+" + rec.source_system_id] =
              rec.status_type;
          });
        }
      })
      .catch(e => {
        console.error("fetchOverlayStatusByRecordIds error; ", e);
        toast.error(
          "Something went wrong while fetching overlay status of the the records"
        );
      });
    return result;
  };

  const fetchOverlayStatusByQuarantineRecordIds = async reqBody => {
    let result = {};
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/quarantine/recordIdsByType`;
    const mockUrl = `/quarantineRecordsByType.json`;
    const config = {
      method: "POST",
      body: JSON.stringify({
        records: reqBody,
        severity: "Hard"
      }),
      headers: {
        clientId: selectedClient.oid,
        "Content-Type": "application/json"
      }
    };
    await fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        if (response.data && response.data.length > 0) {
          setQuarantineRecords(response.data);
          response.data.forEach(rec => {
            result[rec.sourceEntityId + "+" + rec.sourceSystemId] = rec.type;
          });
        }
      })
      .catch(e => {
        console.error("fetchOverlayStatusByQuarantineRecordIds error; ", e);
        toast.error(
          "Something went wrong while fetching overlay status of the the quarantine records"
        );
      });
    return result;
  };

  const fetchLinkageHistory = React.useCallback(() => {
    let results = [];
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/linkage/${goldenId}/history`;
    const mockUrl = `/getLinkageHistory.json`;
    const config = {
      credentials: "include",
      headers: {
        clientId: selectedClient.oid,
        "Content-Type": "application/json",
        userId: user.username
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        setLinkageHistory(response.data);
      })
      .catch(e => {
        console.log("Linkage History error: ", e.message);
      });
  }, [selectedClient.oid, goldenId]);

  const fhirBundleDataExtractor = React.useCallback(
    async (data, doRelatedSearch) => {
      if (isNewQuarantine) {
        data = [];
        const quarantineDemographicsJSON = JSON.parse(`{
          "resourceType": "Patient",
          "id": "${quar_recordId}",
          "meta": {
              "source": "${quar_sourceId}"
          },
          "deceasedBoolean": false,
          "link": [
              {
                  "other": {
                      "reference": ""
                  },
                  "type": "seealso"
              }
          ]
      }`);
        quarantineDemographicsJSON.isQuarantine = true;
        quarantineDemographicsJSON.scoreString = "";
        const quarantinePrimaryRecord = {
          records: [quarantineDemographicsJSON],
          table: "primary",
          id: "",
          scoreString: ""
        };
        data[0] = quarantinePrimaryRecord;
      }

      data[0].threshold ? setThreshold(data[0].threshold) : setThreshold("-");
      data[0].eimpLastUpdated
        ? setAggregateEimpLastUpdated(data[0].eimpLastUpdated)
        : setAggregateEimpLastUpdated("-");

      data[0].table = "primary";

      let primaryRecordList = fhirToDatatable(
        data.slice(0, 1),
        sourcesMap,
        nameToTypeMap
      );
      let secondaryRecordList = fhirToDatatable(
        data.slice(1).map(value => {
          value.table = "secondary";
          return value;
        }),
        sourcesMap,
        nameToTypeMap
      );

      let allRecordWithSource = null;
      if (isNewQuarantine) {
        console.log("Here in isNew");
        console.log("quar record id ", quar_recordId);
        allRecordWithSource = [
          {
            sourceEntityId: quar_recordId,
            sourceSystemId: quar_sourceId
          }
        ];
      } else {
        allRecordWithSource = primaryRecordList
          .filter(record => !record.actions)
          .map(record => {
            return {
              sourceEntityId: record.sourceEntityId,
              sourceSystemId: record.source
            };
          })
          .concat(
            secondaryRecordList
              .filter(record => !record.actions)
              .map(record => {
                return {
                  sourceEntityId: record.sourceEntityId,
                  sourceSystemId: record.source
                };
              })
          );
      }

      const overlayStatusByRecordIdsResponse = await fetchOverlayStatusByRecordIds(
        allRecordWithSource
      );
      if (
        overlayStatusByRecordIdsResponse &&
        Object.keys(overlayStatusByRecordIdsResponse).length > 0
      ) {
        primaryRecordList = primaryRecordList.map(record => {
          if (overlayStatusByRecordIdsResponse.hasOwnProperty(record.id)) {
            record.overlayStatus =
              overlayStatusByRecordIdsResponse[record.id] !== "Reviewed";
          }
          return record;
        });

        secondaryRecordList = secondaryRecordList.map(record => {
          if (overlayStatusByRecordIdsResponse.hasOwnProperty(record.id)) {
            record.overlayStatus =
              overlayStatusByRecordIdsResponse[record.id] !== "Reviewed";
          }
          return record;
        });
      }
      const overlayStatusByQuarantineRecordIdsResponse = await fetchOverlayStatusByQuarantineRecordIds(
        allRecordWithSource
      );
      if (
        overlayStatusByQuarantineRecordIdsResponse &&
        Object.keys(overlayStatusByQuarantineRecordIdsResponse).length > 0
      ) {
        primaryRecordList = primaryRecordList.map(record => {
          if (
            overlayStatusByQuarantineRecordIdsResponse.hasOwnProperty(record.id)
          ) {
            record.quarantineStatus = true;
            record.quarantineOverlayStatus =
              overlayStatusByQuarantineRecordIdsResponse[record.id] ===
              "ProblematicOverlay";
          }
          return record;
        });
        secondaryRecordList = secondaryRecordList.map(record => {
          if (
            overlayStatusByQuarantineRecordIdsResponse.hasOwnProperty(record.id)
          ) {
            record.quarantineStatus = true;
            record.quarantineOverlayStatus =
              overlayStatusByQuarantineRecordIdsResponse[record.id] ===
              "ProblematicOverlay";
          }
          return record;
        });
      }

      setPrimaryRecords(primaryRecordList);
      setPrimaryRecordsFiltered(
        primaryRecordList.filter(record => !record.actions)
      );

      setGoldenId(primaryRecordList[0].goldenId);
      setSecondaryRecords(secondaryRecordList);
      setExpandedPrimaryRecords(data[0].records);

      const scoreStrings = data[0].records.map(patient => patient.scoreString);
      scoreRef.current = scoreStrings;

      setExpandedSecondaryRecords(
        extractExpandedSecondaryRecords(data.slice(1))
      );
      setPrimarySpecId(data[0] ? data[0].identitySpecID : "");

      const allRecords = data[0].records.concat(
        extractExpandedSecondaryRecords(data.slice(1))
      );
      await identitySpecHandler(allRecords, data[0].identitySpecID);

      if (doRelatedSearch && isRelatedIdentitesSearch) {
        fetchFhirBundle(true);
      }
    },
    [identitySpecHandler, sourcesMap, isNewQuarantine]
  );

  const constructMactcherSearchRequestBody = findPatientRequestBody => {
    const matcherSearchRequestBody = {};
    matcherSearchRequestBody.patient = {};
    matcherSearchRequestBody.patient.resourceType = "Patient";
    const patientReq = findPatientRequestBody;
    for (let key in patientReq) {
      if (key === "addresses") {
        matcherSearchRequestBody.patient.address = patientReq[key];
      }
      if (key === "gender") {
        matcherSearchRequestBody.patient.gender =
          patientReq[key] === "m"
            ? "male"
            : patientReq[key] === "f"
            ? "female"
            : "unknown";
      }
      if (key === "birthTime") {
        matcherSearchRequestBody.patient.birthDate =
          patientReq[key].slice(0, 4) +
          "-" +
          patientReq[key].slice(4, 6) +
          "-" +
          patientReq[key].slice(6);
      }
      if (key === "ids") {
        let isSourceIdExist = false;
        for (let subkey in patientReq) {
          if (subkey === "sourceId") {
            matcherSearchRequestBody.patient.id = patientReq[key][0].value;
            isSourceIdExist = true;
            break;
          }
        }
        if (!isSourceIdExist) {
          matcherSearchRequestBody.patient.identifier = matcherSearchRequestBody
            .patient.identifier
            ? matcherSearchRequestBody.patient.identifier.concat(
                patientReq[key]
              )
            : patientReq[key];
        }
      }
      if (key === "ssn") {
        let ids = matcherSearchRequestBody.patient.identifier
          ? [...matcherSearchRequestBody.patient.identifier]
          : [];
        ids.push({ system: "2.16.840.1.113883.4.1", value: patientReq[key] });
        matcherSearchRequestBody.patient.identifier = ids;
      }
      if (key === "mbi") {
        let ids = matcherSearchRequestBody.patient.identifier
          ? [...matcherSearchRequestBody.patient.identifier]
          : [];
        ids.push({ system: "2.16.840.1.113883.4.927", value: patientReq[key] });
        matcherSearchRequestBody.patient.identifier = ids;
      }

      if (key === "hicn") {
        let ids = matcherSearchRequestBody.patient.identifier
          ? [...matcherSearchRequestBody.patient.identifier]
          : [];
        ids.push({
          system: "http://hl7.org/fhir/sid/us-medicare",
          value: patientReq[key]
        });
        matcherSearchRequestBody.patient.identifier = ids;
      }

      if (key === "policySubscriber") {
        let ids = matcherSearchRequestBody.patient.identifier
          ? [...matcherSearchRequestBody.patient.identifier]
          : [];
        ids.push({
          system: "",
          value: patientReq[key],
          type: {
            coding: [
              {
                system:
                  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#identifier-codes",
                code: "COV",
                display: "COV"
              }
            ]
          }
        });
        matcherSearchRequestBody.patient.identifier = ids;
      }
      if (key === "telecom" || key === "email") {
        let telecom = matcherSearchRequestBody.patient.telecom
          ? [...matcherSearchRequestBody.patient.telecom]
          : [];
        let telecomKey = "email";
        if (key === "telecom") {
          telecomKey = "phone";
        }
        telecom.push({ system: telecomKey, value: patientReq[key] });
        matcherSearchRequestBody.patient.telecom = telecom;
      }
      if (key === "names") {
        matcherSearchRequestBody.patient.name = patientReq[key];
      }
      if (key === "sourceId") {
        matcherSearchRequestBody.patient.meta = {};
        matcherSearchRequestBody.patient.meta.source = patientReq[key];
      }
      if (key === "link") {
        matcherSearchRequestBody.patient.link = patientReq[key];
      }
    }
    return matcherSearchRequestBody;
  };

  const [eidInsightsData, setEidInsightsData] = React.useState(null);
  const [insightsLoading, setInsightsLoading] = React.useState(false);
  const [insightsError, setInsightsError] = React.useState(null);

  const fetchEidInsights = async goldenId => {
    const apiUrl = `/api/identity/individual/eimp-ai/1.0.0/eid/${goldenId}/insights`;

    const requestBody = {
      message: `Generate insights for EID ${goldenId}`,
      thread_id: ""
    };

    try {
      setInsightsLoading(true);
      setInsightsError(null);
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Upstream-Env": process.env.REACT_APP_HCP_ENV
        },
        body: JSON.stringify(requestBody)
        // credentials: "omit"
      });

      if (!response.ok) {
        const errorBody = await response.text();
        console.error(
          `API Error: ${response.status} ${response.statusText}`,
          "Response Body:",
          errorBody
        );
        // Handle 401 or other errors locally without affecting the session
        if (response.status === 401) {
          setInsightsError("Unauthorized: Unable to fetch insights.");
          return null;
        }
        // Set error state but don't throw or redirect
        setInsightsError(
          `API returned ${response.status}: ${response.statusText}`
        );
        return null;
      }

      const data = await response.json();
      console.log("EID Insights:", data);
      setEidInsightsData(data);
      return data;
    } catch (error) {
      console.error("Error fetching EID insights:", error);
      setInsightsError(error.message || "Failed to fetch insights");
      return null;
    } finally {
      setInsightsLoading(false);
    }
  };

  //Matcher search API call
  const fetchFhirBundle = React.useCallback(
    async (
      searchRelatedIdentities = false,
      isIdSpecOperationPerformed = false,
      doRelatedSearch = false
    ) => {
      if (!isNewQuarantine) {
        setRecordListLoadingState(true);
        window.scrollTo(0, 0);

        const searchRequestPayload = searchRelatedIdentities
          ? createSearchPayload(searchCriteria, undefined, true, isImdm)
          : createSearchPayload(searchCriteria, undefined, undefined, isImdm);
        let data = {};
        let includeRelatedIdentities = true;
        let doTimeoutRetry = false;
        if (searchRelatedIdentities) {
          for (let i = 0; i < searchCriteria.length; i++) {
            if (
              searchCriteria[i].key === "golden_id" ||
              searchCriteria[i].key === "record_id"
            ) {
              doTimeoutRetry = true;
            }
          }
          data = constructMactcherSearchRequestBody(searchRequestPayload);
        } else {
          doTimeoutRetry = true;
          data = {
            patient: {
              resourceType: "Patient",
              link: [
                {
                  other: {
                    reference: goldenId
                  },
                  type: "seealso"
                }
              ],
              ...searchRequestPayload
            }
          };
        }
        const url = isImdm
          ? `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/match?include_related_identities=${includeRelatedIdentities}`
          : `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/match?`;
        // const mockUrl = searchRelatedIdentities ? `/closeMatches2.json` : `/closeMatches.json`;
        const mockUrl = isIdSpecOperationPerformed
          ? `/MatcherSearchResultWithNoIdentityFound.json`
          : searchRelatedIdentities
          ? `/closeMatches2.json`
          : `/closeMatches.json`;
        const config = {
          method: "POST",
          body: JSON.stringify(data),
          credentials: "include",
          headers: {
            clientId: selectedClient.oid,
            "Content-Type": "application/json",
            userId: userId
          }
        };

        try {
          let response = await fetch(...fetchConfig(url, mockUrl, config));
          if (isImdm && doTimeoutRetry && response.status === 504) {
            includeRelatedIdentities = false;
            const newurl = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/match?include_related_identities=${includeRelatedIdentities}`;
            toast.error(
              "Search has taken longer than expected, so ignoring related identities"
            );
            response = await fetch(...fetchConfig(newurl, mockUrl, config));
          }
          response = await handleResponse(response);
          setMatchApiResponse(response.data);
          let isrestricted = response.isRestricted == "true" ? true : false;
          let restrictedeids = response.RestrictedEids;
          if (
            isrestricted &&
            restrictedeids != "null" &&
            restrictedeids.length > 0
          ) {
            restrictedeids = restrictedeids.replaceAll("Patient/", "");
            setisRestricted(true);
            setRestrictedEids(restrictedeids);
            setshowRestrictedDialog(true);
          }

          setRecordListLoadingState(false);
          setIsIdSpecPerformed(true);
          if (
            "total" in response.data &&
            response.data.total === 1 &&
            !searchRelatedIdentities &&
            isIdSpecOperationPerformed
          ) {
            await fetchMatcherSearchWithRecordIdAndSource();
          } else if (
            "total" in response.data &&
            response.data.total === 1 &&
            searchRelatedIdentities
          ) {
            toast.info("No Results found for the search");
          } else if (
            "total" in response.data &&
            response.data.total > 1 &&
            searchRelatedIdentities
          ) {
            constructSearchRelatedIdentitiesData(
              fhirBundleParser(response.data)
            );
            setIsRelatedIdentitesSearch(true);
          } else if ("total" in response.data && response.data.total === 1) {
            throw Error("Identity does not exist");
          } else {
            let data = fhirBundleParser(response.data);

            // if (goldenId) {
            //   fetchEidInsights(goldenId)
            //     .then(eidInsights => {
            //       console.log("Fetched EID Insights:", eidInsights);
            //     })
            //     .catch(error => {
            //       console.error("Error fetching EID insights:", error);
            //     });
            // }
            fhirBundleDataExtractor(data, doRelatedSearch);
            if (isImdm) {
              callDiagnose(goldenId);
            }
            focusedIdFhirBundleRef.current = focusIdFhirBundle(response.data);

            if (data != []) {
              setRecordIDToFhirMap(prepareRecordIdToFhirMap(response.data));
            }
          }
        } catch (e) {
          console.log("ERRORRR ", e);
          setRecordListLoadingState(false);
          const errorMessage =
            e.message === "Identity does not exist"
              ? e.message
              : "Failed to fetch records";
          // window.newrelic.noticeError(`Err in match api`, e);
          toast.error(errorMessage);
          history.push("/search-identities-new");
        }
      }
    },
    [
      goldenId,
      toast,
      selectedClient.oid,
      searchCriteria,
      fhirBundleDataExtractor,
      isNewQuarantine
      // fetchFhirRecords
    ]
  );

  const ShowRestrictedDialog = () => {
    return (
      <Modal
        open={showRestrictedDialog}
        onClose={() => setshowRestrictedDialog(false)}
      >
        <h4 style={{ textAlign: "center", marginBottom: "20px" }}>
          You are not authorized to view EID's {RestrictedEids} in Related
          Identities Section due to data governance restriction/compliance.
        </h4>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Button
            onClick={() => {
              setshowRestrictedDialog(false);
            }}
          >
            OK
          </Button>
        </div>
      </Modal>
    );
  };

  const prepareRecordIdToFhirMap = jsonBundle => {
    let fhirMap = [];
    if (jsonBundle.resourceType.toLowerCase() === "bundle") {
      if (jsonBundle.total > 1) {
        let entries = jsonBundle.entry;
        if (!entries[0].resource.id) {
          entries.splice(0, 1);
        }
        entries.forEach(entry => {
          if (entry.resource && entry.resource.link) {
            const recordId = entry.resource.id;
            const source = entry.resource.meta.source;
            fhirMap.push({
              recordId: source + "|" + recordId,
              data: entry.resource
            });
          }
        });
        return fhirMap;
      } else return [];
    } else return [];
  };

  const fetchMatcherSearchWithRecordIdAndSource = async () => {
    setRecordListLoadingState(true);
    window.scrollTo(0, 0);
    const data = formRecordIDSourceIdCombinationMatcherSearchPayload();
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/match`;
    const mockUrl = `/closeMatches2.json`;
    const config = {
      method: "POST",
      body: JSON.stringify(data),
      credentials: "include",
      headers: {
        clientId: selectedClient.oid,
        "Content-Type": "application/json",
        userId: userId
      }
    };
    await fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(async response => {
        setRecordListLoadingState(false);
        setIsIdSpecPerformed(true);
        if ("total" in response.data && response.data.total === 1) {
          throw Error("No Search Results found!");
        } else {
          let data = fhirBundleParser(response.data);
          await fhirBundleDataExtractor(data);
        }
      })
      .catch(e => {
        console.log("fetchFhirBundle error: ", e.message);
        setRecordListLoadingState(false);
        const errorMessage =
          e.message === "No Search Results found!"
            ? e.message
            : "Failed to fetch records";
        toast.error(errorMessage);
        history.push("/search-identities-new");
      });
  };

  const fetchMembershipHistory = (recordId, sourceId, table) => {
    const url_encoded_id = encodeURIComponent(recordId);
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/record/${url_encoded_id}/membershiphistory`;
    const encoded_url = encodeURI(url);
    const mockUrl = `/membershipHistory.json`;
    const config = {
      credentials: "include",
      headers: {
        clientId: selectedClient.oid,
        sourceId: sourceId,
        "Content-Type": "application/json",
        "cache-control": "max-age=0, no-store",
        userId: userId
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        const membershipHistory = response.data;
        for (let item of membershipHistory) {
          item.lastUpdated = moment(item.lastUpdated)
            .tz(user.preferences.timeZone)
            .format("L, LTS z");
        }
        const recordList =
          table === "primary" ? [...primaryRecords] : [...secondaryRecords];
        const expandedRecord = recordList.find(ar => ar.recordId === recordId);
        expandedRecord.membershipDetails = membershipHistory;
        // assigning the latest history
        table === "primary"
          ? setPrimaryRecords(recordList)
          : setSecondaryRecords(recordList);
      })
      .catch(e => {
        console.log("fetchMembershipHistory error: ", e);
      });
  };

  const fetchImdmMembershipHistory = (recordId, sourceId, table) => {
    const url_encoded_id = encodeURIComponent(recordId);
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/record/${url_encoded_id}/clientmembershiphistory`;
    const encoded_url = encodeURI(url);
    const mockUrl = `/imdmMembershipHistory.json`;
    const config = {
      credentials: "include",
      headers: {
        clientId: selectedClient.oid,
        sourceId: sourceId,
        "Content-Type": "application/json",
        "cache-control": "max-age=0, no-store",
        userId: userId
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        const imdmMembershipHistory = response.data;
        for (let item of imdmMembershipHistory) {
          item.lastUpdated = moment(item.lastUpdated)
            .tz(user.preferences.timeZone)
            .format("L, LTS z");
        }
        const recordList =
          table === "primary" ? [...primaryRecords] : [...secondaryRecords];

        const expandedRecord = recordList.find(ar => ar.recordId === recordId);
        expandedRecord.imdmMembershipDetails = imdmMembershipHistory;
        table === "primary"
          ? setPrimaryRecords(recordList)
          : setSecondaryRecords(recordList);
      })
      .catch(e => {
        console.log("fetchImdmMembershipHistory error: ", e);
      });
  };

  const extractExpandedSecondaryRecords = secondaryidentities => {
    let secondaryRecords = [];
    let secondaryRecordsObj = secondaryidentities.map(ele => ele.records);
    for (let records of secondaryRecordsObj) {
      for (let record of records) {
        secondaryRecords.push(record);
      }
    }
    return secondaryRecords;
  };

  const addAllRecordsForComparision = (records, expandedRecords, checked) => {
    const clone = new Map(recordComparisonList);
    records.forEach(record => {
      if (checked) {
        if (!clone.has(record.id)) {
          const resource = expandedRecords.find(rec => {
            return (
              rec.id === record.sourceEntityId &&
              rec.meta.source === record.source
            );
          });
          if (resource) clone.set(record.id, resource);
        }
      } else {
        if (clone.has(record.id)) {
          clone.delete(record.id);
        }
      }
      setRecordComparisonList(clone);
    });
  };

  const addRecordsForComparison = record => {
    const clone = new Map(recordComparisonList);
    if (clone.has(record.original.id)) {
      clone.delete(record.original.id);
    } else {
      // if (recordComparisonList.size >= 20) {
      //   setCompareRecordsDialog(true);
      //   return;
      // }
      const resourcePrimary = expandedPrimaryRecords.find(
        rec =>
          rec.id === record.original.recordId &&
          rec.meta.source === record.original.source
      );
      const resourceSecondary = expandedSecondaryRecords.find(
        rec =>
          rec.id === record.original.recordId &&
          rec.meta.source === record.original.source
      );
      const resource = resourcePrimary ? resourcePrimary : resourceSecondary;
      clone.set(record.original.id, resource);
    }

    setRecordComparisonList(clone);
  };

  const actionCell = ({ row }) => {
    if (isNewQuarantine) {
      return null;
    }
    return (
      <>
        <ButtonList>
          <CheckBox
            onChange={() => addRecordsForComparison(row)}
            selected={recordComparisonList.has(row.original.id)}
          />
          <LinkButton
            icon="add"
            title={
              row.original.identitySpecID &&
              row.original.identitySpecID !== primarySpecId
                ? "Include is disabled as it has idspec already"
                : "Include"
            }
            className={`${
              selectedRowsMap.get(row.original.id) &&
              selectedRowsMap.get(row.original.id).operation === "include"
                ? styles.selectedBtn
                : ""
            }`}
            disabled={
              row.original.identitySpecID &&
              row.original.identitySpecID !== primarySpecId
            }
            onClick={() => {
              actionCellHandler("include", row);
            }}
          />
          <LinkButton
            icon="subtract"
            title="Exclude"
            className={`${
              selectedRowsMap.get(row.original.id) &&
              selectedRowsMap.get(row.original.id).operation === "exclude"
                ? styles.selectedBtn
                : ""
            }`}
            onClick={() => {
              actionCellHandler("exclude", row);
            }}
          />
        </ButtonList>
      </>
    );
  };

  const actionCellHandler = (type, row) => {
    const clonedMap = toggler(selectedRowsMap, row, type, preSelectedRowsMap);
    setActionCounts(
      actionCountsHandler(!clonedMap.size ? preSelectedRowsMap : clonedMap)
    );
    setSelectedRowsMap(clonedMap);

    //Merge Identiyspec button disable if any manual operations perfomed
    if (
      mergeIdentitySpecEnableDisableMap &&
      mergeIdentitySpecEnableDisableMap.has(row.original.goldenId)
    ) {
      const mergeButtonIdspecMap = new Map(mergeIdentitySpecEnableDisableMap);

      if (clonedMap.has(row.original.id)) {
        mergeButtonIdspecMap.get(row.original.goldenId).add(row.original.id);
      } else {
        mergeButtonIdspecMap.get(row.original.goldenId).delete(row.original.id);
      }
      setMergeIdentitySpecEnableDisableMap(mergeButtonIdspecMap);
    }
  };

  const idCell = ({ row }) => {
    //                onClick={setRecordOverrideDialogContent(true);
    //                                       setRecordOverride({expandableData.find(
    //                                             record =>
    //                                               `${record.id}+${record.meta.source}` === row.original.id
    //setRecordOverridePayload(prepareOverrideRequest(true))
    //                                           )});}
    return row.original.scoreId ? null : (
      <div style={{ display: "flex", flexDirection: "row" }}>
        {/* <Link
          to={{
            pathname: `/search-identities-new/${selectedClient.oid}/view/${row.original.goldenId}/`,
            state: {
              preLoadedSearchCriteria: [
                {
                  key: "golden_id",
                  label: "HCM ID/EID",
                  value: row.original.goldenId
                }
              ]
            }
          }}
          onClick={() => {
            history.push({
              pathname: `/search-identities-new/${selectedClient.oid}/view/${row.original.goldenId}/`,
              state: {
                preLoadedSearchCriteria: [
                  {
                    key: "golden_id",
                    label: "HCM ID/EID",
                    value: row.original.goldenId
                  }
                ]
              }
            });
            window.location.reload();
          }}
          style={{ textDecoration: "none" }}
        >
          <LinkButton
            icon="arrow_wtail_bold_up"
            style={{ width: "50%", float: "left" }}
          />
        </Link> */}

        {/* //row.original.identitySpecID &&
              row.original.identitySpecID !== primarySpecId */}

        {row.original.hasOverride && (
          <LinkButton
            icon="process"
            style={{
              color: "mediumvioletred"
            }}
            onClick={() => {
              setRecordOverride(
                row.original.table === "primary"
                  ? expandedPrimaryRecords.find(
                      record =>
                        `${record.id}+${record.meta.source}` === row.original.id
                    )
                  : expandedSecondaryRecords.find(
                      record =>
                        `${record.id}+${record.meta.source}` === row.original.id
                    )
              );
              setRecordOverrideDialogContent({
                reviewOverrideType: "all",
                overrideIconClicked: true
              });
            }}
          />
        )}

        {(row.original.overlayStatus ||
          row.original.quarantineOverlayStatus) && (
          <Link
            to={{
              pathname: row.original.quarantineOverlayStatus
                ? "/RecordOverlayReviewQueue/QuarantineRecord"
                : "/RecordOverlayReviewQueue/OverlayRecord",
              state: {
                category: "dynamicReviewQueue",
                sourceEntityId: row.original.sourceEntityId,
                sourceSystemId: row.original.source,
                searchOverlay: true
              }
            }}
            style={{ textDecoration: "none" }}
          >
            <LinkButton
              icon="overlay_icon"
              style={{
                width: "50%",
                float: "left",
                color: row.original.quarantineOverlayStatus
                  ? "red"
                  : "dodgerblue"
              }}
            />
          </Link>
        )}

        {!isNewQuarantine && (
          <CopyButton
            hcmID={row.original.goldenId}
            recordID={row.original.recordId}
            idNumber={row.original.goldenIdNumber}
            hasLeftIcon={row.original.overlayStatus}
          />
        )}
      </div>
    );
  };

  const lastUpdatedTimeCell = ({ row }) => {
    return row.original.eimpLastUpdated
      ? formattedDateWithDefault(row.original.eimpLastUpdated)
      : row.original.scoreId
      ? null
      : "-";
  };

  const lastUpdatedCell = ({ row }) => {
    return row.original.lastupdated
      ? formattedDateWithDefault(row.original.lastupdated)
      : row.original.scoreId
      ? null
      : "-";
  };

  //Record Options (The three dots Button)
  const detailOptionsCell = ({ row }) => {
    const recordOptionsHandler = e => {
      setSelectedRecord(row.original.id);
      setRowPopoverVisible(true);
      e.stopPropagation();
    };

    const recordDetailsHandler = () => {
      // expandDetails(row.original.id);
      expandDetails(row.original);
      setRowPopoverVisible(false);
    };

    const deleteRecordHandler = () => {
      setAction("delete");
      setSelectedRecordHandler(row);
    };

    const multipleAttributeOverrideHandler = () => {
      const restrictedSources = ["TMX_LN"];
      if (restrictedSources.includes(row.original.source)) {
        toast.error(
          `Override is not allowed for records with source code ${row.original.source}.`
        );
        return; // Prevent further execution
      }
      setSelectedMultipleAttributeOverrideHandler(row);
    };

    return (
      <RecordOptions
        onRecordOptionsclick={recordOptionsHandler}
        onRecordDetailsClick={recordDetailsHandler}
        onDeleteRecordClick={deleteRecordHandler}
        onOverrideRecordClick={multipleAttributeOverrideHandler}
        row={row}
        selectedRecord={selectedRecord}
        rowPopOverVisible={rowPopOverVisible}
        focussedIdentityTable={row.original.table === "primary"}
        isReviewQueueTable={is_review_queue_page}
        isNewQuarantine={isNewQuarantine}
        isInvisible={checkReadOnlyUser(user)}
      />
    );
  };

  //delete API call
  const deleteRecordHandler = ({ deleteReason }) => {
    setDeleteConfirmationDialog(false);
    const data = {
      sourceEntityID: selectedDeleteRecord.original.sourceEntityId,
      deleteReason,
      userID: user.username
    };
    fetch(
      `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patientsource`,
      {
        method: "DELETE",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          clientId: selectedClient.oid,
          sourceId: selectedDeleteRecord.original.source,
          "Content-Type": "application/json",
          userId: userId
        }
      }
    )
      .then(handleResponse)
      .then(response => {
        if (primaryRecords.length > 1) {
          toast.success("Record deleted successfully from identity");
          fetchFhirBundle();
          fetchLinkageHistory();
          fetchAggregate();
        } else {
          toast.success(
            "Record deleted successfully from identity. As there are no more records in the identity, you are being redirected to the search page."
          );
          history.push("/search-identities-new");
        }
      })
      .catch(error => {
        console.log("delete error: ", error);

        if (error.metaData && error.metaData.error) {
          toast.error(`Failed to delete from identity`);
          return;
        }
        toast.error("Connection to client identity service failed");
      });
  };

  const getColumnWidth = (accessor, headerText) => {
    const magicSpacing = 9.8;
    const cellLengthPrimary = Math.max(
      ...primaryRecords.map(
        primaryRecord =>
          `${primaryRecord[accessor] ? primaryRecord[accessor] : ""}`.length
      ),
      ...secondaryRecords.map(
        secondaryRecord =>
          `${secondaryRecord[accessor] ? secondaryRecord[accessor] : ""}`.length
      ),
      headerText.length
    );
    return (cellLengthPrimary * magicSpacing + 45).toLocaleString() + "px";
  };

  const identifierColumns = [];

  const renderedValuesMap = new Map(); // Track rendered values and their row indices

  identifiersConfig.forEach(identifier => {
    const accessor = identifier.heading.toLowerCase();

    if (accessor === "ssn" || accessor === "mbi") {
      identifierColumns.push({
        Header: identifier.heading,
        accessor,
        style: {
          width: getColumnWidth(accessor, identifier.heading)
        },
        Cell: ({ value, row }) => {
          const rowIndex = row.index; // Get the current row index

          // Check if the global toggle is turned on and the value is unique
          const isBold =
            highlightAll &&
            (!renderedValuesMap.has(value) ||
              renderedValuesMap.get(value) === rowIndex);

          // Update the map with the current row index for the value
          if (!renderedValuesMap.has(value)) {
            renderedValuesMap.set(value, rowIndex);
          }

          return (
            <span
              style={{
                background:
                  highlightAll && value && value !== "-"
                    ? accessor === "ssn"
                      ? ssnColorMap[value]
                      : mbiColorMap[value]
                    : "transparent",
                fontWeight: isBold ? "bold" : "normal", // Apply bold styling only when the global toggle is on
                padding: "2px 6px",
                borderRadius: "4px",
                display: "inline-block"
              }}
            >
              {value || "-"}
            </span>
          );
        }
      });
      return;
    }

    // Default for other identifiers
    identifierColumns.push({
      Header: identifier.heading,
      accessor,
      style: {
        width: getColumnWidth(accessor, identifier.heading)
      }
    });
  });

  const renderedGivenNameMap = new Map();
  const columnsPrimary = [
    {
      Header: () => (
        <span style={{ display: "inline-flex" }}>
          {!isNewQuarantine && (
            <CheckBox
              selected={primarySelectAllCheckBox}
              onChange={event => {
                setPrimarySelectAllCheckBox(event.target.checked);
                addAllRecordsForComparision(
                  primaryRecords,
                  expandedPrimaryRecords,
                  event.target.checked
                );
              }}
            />
          )}
          {!isNewQuarantine ? (
            <div>
              &nbsp;&nbsp;
              <span>Actions</span>
            </div>
          ) : null}
        </span>
      ),
      accessor: "actions",
      sticky: "left",
      style: {
        left: 0,
        zIndex: isNewQuarantine ? 0 : 999,
        width: isNewQuarantine ? 0 : 140
      },
      Cell: actionCell
    },
    {
      Header: "ID #",
      accessor: "idNumber",
      style: {
        width: getColumnWidth("idNumber", "ID #    ")
      },
      Cell: idCell
    },
    {
      Header: "HRN",
      accessor: "hrn",
      style: {
        width: getColumnWidth("hrn", "HRN")
      }
    },
    {
      Header: "Source Code",
      accessor: "source",
      sticky: "left",
      style: {
        zIndex: 998,
        left: isNewQuarantine ? 0 : 139,
        minWidth: getColumnWidth("source", "Source Code")
      }
    },
    {
      Header: "Record ID",
      accessor: "recordId",
      sticky: "left",
      style: {
        zIndex: 998,
        left: isNewQuarantine ? 140 : 278,
        width: getColumnWidth("recordId", "Record ID")
      }
    },
    {
      Header: "Source",
      accessor: "sourceName",
      style: {
        minWidth: getColumnWidth("sourceName", "Source")
      }
    },
    {
      Header: "Policy Number",
      accessor: "policyNum",
      style: {
        width: getColumnWidth("policyNum", "Policy Number")
      }
    },
    {
      Header: "Dependent Code",
      accessor: "dependentCd",
      style: {
        width: getColumnWidth("dependentCd", "Dependent Code")
      }
    },
    {
      Header: "Division Code",
      accessor: "divisionCd",
      style: {
        width: getColumnWidth("divisionCd", "Division Code")
      }
    },
    {
      Header: "Relationship Code",
      accessor: "relationshipCd",
      style: {
        width: getColumnWidth("relationshipCd", "Relationship Code")
      }
    },
    {
      Header: "Family ID",
      accessor: "familyID",
      style: {
        width: getColumnWidth("familyID", "Family Id")
      }
    },
    {
      Header: "Member ID",
      accessor: "memberID",
      style: {
        width: getColumnWidth("memberID", "Member Id")
      }
    },
    {
      Header: "Subscriber ID",
      accessor: "subscriberID",
      style: {
        width: getColumnWidth("subscriberID", "Subscriber Id")
      }
    },
    {
      Header: "Carrier ID",
      accessor: "carrierID",
      style: {
        width: getColumnWidth("carrierID", "Carrier Id")
      }
    },
    {
      Header: "Account ID",
      accessor: "accountID",
      style: {
        width: getColumnWidth("accountID", "Account Id")
      }
    },
    {
      Header: "Group ID",
      accessor: "groupID",
      style: {
        width: getColumnWidth("groupID", "Group Id")
      }
    },
    {
      Header: "Original System ID",
      accessor: "origSysId",
      style: {
        width: getColumnWidth("origSysId", "Original System Id")
      }
    },
    {
      Header: "Medicaid RN ",
      accessor: "medicaidRN",
      style: {
        width: getColumnWidth("medicaidRN", "Medicaid RN")
      }
    },
    {
      Header: "Coverage End Date",
      accessor: "coverageEndDate",
      style: {
        width: getColumnWidth("coverageEndDate", "Coverage End Date")
      }
    },
    {
      Header: "Last Updated",
      accessor: "lastupdated",
      style: {
        width: getColumnWidth("lastupdated", "Last Updated")
      },
      Cell: lastUpdatedTimeCell
    },

    {
      Header: "Last Updated By Source",
      accessor: "lastUpdatedBySource",
      style: {
        width: getColumnWidth("lastUpdatedBySource", "Last Updated By Source")
      },
      Cell: lastUpdatedCell
    },

    {
      Header: "Given Name",
      accessor: "givenName",
      style: {
        width: getColumnWidth("givenName", "Given Name")
      },
      Cell: ({ value, row }) => {
        // Use a global map to track unique values across all rows
        const rowIndex = row.index; // Get the current row index

        // Check if the value is unique and the toggle is enabled
        const isBold =
          highlightAll &&
          (!renderedGivenNameMap.has(value) ||
            renderedGivenNameMap.get(value) === rowIndex);

        // Update the global map with the current row index for the value
        if (!renderedGivenNameMap.has(value)) {
          renderedGivenNameMap.set(value, rowIndex);
        }

        return (
          <span
            style={{
              background:
                highlightAll && value && value !== "-"
                  ? givenNameColorMap[value] || "transparent"
                  : "transparent", // Apply color coding
              fontWeight: isBold ? "bold" : "normal", // Apply bold styling only for unique values when toggle is on
              padding: "2px 6px",
              borderRadius: "4px",
              display: "inline-block"
            }}
          >
            {value || "-"}
          </span>
        );
      }
    },
    {
      Header: "Suffix",
      accessor: "suffixName",
      style: {
        width: getColumnWidth("suffixName", "Suffix")
      }
    },
    {
      Header: "Family Name",
      accessor: "familyName",
      style: {
        width: getColumnWidth("familyName", "Family Name")
      }
    },
    {
      Header: "Date Of Birth",
      accessor: "birthDate",
      style: {
        width: getColumnWidth("birthDate", "Date Of Birth")
      },
      Cell: ({ value }) => (
        <span
          style={{
            background:
              highlightAll && value && value !== "-"
                ? dobColorMap[value]
                : "transparent",
            fontWeight: highlightAll ? "bold" : "normal",
            padding: "2px 6px",
            borderRadius: "4px",
            display: "inline-block"
          }}
        >
          {value || "-"}
        </span>
      )
    },
    {
      Header: "Date Of Death",
      accessor: "deceasedDateTime",
      style: {
        width: getColumnWidth("deceasedDateTime", "Date Of Death")
      }
    },
    {
      Header: "Gender",
      accessor: "gender",
      style: {
        width: getColumnWidth("gender", "Gender")
      }
    },
    {
      Header: "Address Line",
      accessor: "addressLine",
      style: {
        width: getColumnWidth("addressLine", "addressLine")
      }
    },
    {
      Header: "City",
      accessor: "city",
      style: {
        width: getColumnWidth("city", "City")
      }
    },
    {
      Header: "State",
      accessor: "state",
      style: {
        width: getColumnWidth("state", "State")
      }
    },
    {
      Header: "Postal Code",
      accessor: "postalCode",
      style: {
        width: getColumnWidth("postalCode", "Postal Code")
      }
    },
    {
      Header: "Household",
      accessor: "household",
      style: {
        width: getColumnWidth("household", "Household")
      }
    },
    {
      Header: "Phone",
      accessor: "phone",
      style: {
        width: getColumnWidth("phone", "Phone")
      }
    },
    {
      Header: "Email",
      accessor: "email",
      style: {
        width: getColumnWidth("email", "Email")
      }
    },
    {
      Header: "Identifiers",
      accessor: "identifiers",
      style: {
        width: getColumnWidth("identifiers", "Identifiers")
      }
    },
    {
      Header: "rxClaims Member ID",
      accessor: "rxClaimsMemberId",
      style: {
        width: getColumnWidth("rxClaimsMemberId", "rxClaims Member ID")
      }
    },
    {
      Header: "rxClaims Supplemental ID",
      accessor: "rxClaimsSupplementalId",
      style: {
        width: getColumnWidth(
          "rxClaimsSupplementalId",
          "rxClaims Supplemental Id"
        )
      }
    },
    {
      Header: "Student Resources ID",
      accessor: "studentResourcesId",
      style: {
        width: getColumnWidth("studentResourceId", "Student Resource ID")
      }
    },
    {
      Header: "RiverValley Member ID",
      accessor: "riverValleyMemberId",
      style: {
        width: getColumnWidth("riverVallyMemberId", "RiverValley Member ID")
      }
    },
    {
      Header: "Oxford Member ID",
      accessor: "oxfordMemberId",
      style: {
        width: getColumnWidth("oxfordMemberId", "Oxford Member ID")
      }
    },
    {
      Header: "Compas Member ID",
      accessor: "compasMemberNumber",
      style: {
        width: getColumnWidth("oxfordMemberId", "Compas Member ID")
      }
    },
    {
      Header: "Nice Member ID",
      accessor: "niceMemberId",
      style: {
        width: getColumnWidth("niceMemberId", "Nice Member ID")
      }
    },
    {
      Header: "Employer Assigned ID",
      accessor: "employerAssignedId",
      style: {
        width: getColumnWidth("employerAssignedId", "Employer Assigned ID")
      }
    },
    {
      Header: "CDB Xref ID",
      accessor: "cdbXrefId",
      style: {
        width: getColumnWidth("cdbXrefId", "CDB Xref ID")
      }
    },
    {
      Header: "Ursula ID",
      accessor: "ursulaId",
      style: {
        width: getColumnWidth("ursulaId", "Ursula ID")
      }
    },
    {
      Header: "Script Med Patient ID",
      accessor: "scriptMedPatientId",
      style: {
        width: getColumnWidth("scriptMedPatientId", "Script Med Patient ID")
      }
    },
    {
      Header: "IRIS Account Number",
      accessor: "irisAccountNumber",
      style: {
        width: getColumnWidth("irisAccountNumber", "IRIS Account Number")
      }
    },
    {
      Header: "Alt ID",
      accessor: "altID",
      style: {
        width: getColumnWidth("altID", "Alt ID")
      }
    },
    ...identifierColumns,
    {
      accessor: "moreoptions",
      sticky: "right",
      style: {
        right: 0,
        zIndex: 99,
        width: 65
      },
      Cell: detailOptionsCell
    }
  ];

  const columnsSecoundry = [...columnsPrimary];
  columnsSecoundry[0] = {
    Header: () => (
      <span style={{ display: "inline-flex" }}>
        {!isNewQuarantine && (
          <CheckBox
            selected={secoundrySelectAllCheckBox}
            onChange={event => {
              setSecoundrySelectAllCheckBox(event.target.checked);
              addAllRecordsForComparision(
                secondaryRecords,
                expandedSecondaryRecords,
                event.target.checked
              );
            }}
          />
        )}
        {!isNewQuarantine && (
          <div>
            &nbsp;&nbsp;
            <span>Actions</span>
          </div>
        )}
      </span>
    ),
    accessor: "actions",
    sticky: "left",
    style: {
      left: 0,
      zIndex: isNewQuarantine ? 0 : 999,
      width: isNewQuarantine ? 0 : 140
    },
    Cell: actionCell
  };

  const fetchRecordHistory = recordId => {
    const [id, sourceId] = recordId.split("+");
    if (recordHistoryList.has(id)) {
      return;
    }
    const url_encoded_id = encodeURIComponent(id);
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/record/${url_encoded_id}/history?includeQuarantineHistory=true`;
    let mockUrl = "";
    if (isNewQuarantine) {
      mockUrl = `/recordHistoryQuarantineNew.json`;
    } else {
      mockUrl = `/recordHistoryQuarantine.json`;
    }
    let headers = {
      clientId: selectedClient.oid,
      sourceId,
      "Content-Type": "application/json",
      userId: userId
    };
    const config = {
      credentials: "include",
      headers: headers
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        const recordHistoryListClone = new Map(recordHistoryList);
        recordHistoryListClone.set(id, response.data);
        setRecordHistoryList(recordHistoryListClone);
      })
      .catch(e => {
        console.log("history error: ", e);
      });
  };

  React.useEffect(() => {
    if (loading) {
      return;
    }
    if (!rq_gid && isNewQuarantine === false) {
      fetchFhirBundle();
      fetchLinkageHistory();
      fetchAggregate();
      checkAssignedRQExistence();
      checkIdinDynamicRQExistence();
    }
  }, [setGoldenId, isNewQuarantine]);

  React.useEffect(() => {
    if (rq_gid && !isIdSpecPerformed && !isNewQuarantine) {
      setGoldenId(rq_gid);
      setIdentity(rq_aggregate);
      fhirBundleDataExtractor(rqFhirBundleData);
    }
  }, [
    rq_gid,
    isIdSpecPerformed,
    rqFhirBundleData,
    rq_aggregate,
    isNewQuarantine
  ]);

  React.useEffect(() => {
    if (goldenId && isImdm) {
      callDiagnose(goldenId);
    }
  }, [goldenId, isImdm, user.role]);

  const expandDetails = (recordDetails, expandQuarantineRecord = false) => {
    const recordList =
      recordDetails.table === "primary"
        ? [...primaryRecords]
        : [...secondaryRecords];
    const clickedRecord = recordList.find(ar => ar.id === recordDetails.id);

    if (expandQuarantineRecord) {
      clickedRecord.isExpanded = true;
    } else {
      clickedRecord.isExpanded = !clickedRecord.isExpanded;
    }
    if (clickedRecord.isExpanded) {
      fetchMembershipHistory(
        clickedRecord.recordId,
        clickedRecord.source,
        clickedRecord.table
      );
      fetchRecordHistory(recordDetails.id);
      recordDetails.table === "primary"
        ? setPrimaryRecords(recordList)
        : setSecondaryRecords(recordList);

      if (isImdm) {
        fetchImdmMembershipHistory(
          clickedRecord.recordId,
          clickedRecord.source,
          clickedRecord.table
        );
      }
    }
  };

  const collapseDetails = (recordId, table) => {
    const recordList =
      table === "primary" ? [...primaryRecords] : [...secondaryRecords];
    const clickedRecord = recordList.find(ar => ar.id === recordId);
    clickedRecord.isExpanded = false;
    table === "primary"
      ? setPrimaryRecords(recordList)
      : setSecondaryRecords(recordList);
  };

  //Column Selector Props
  const shuffleColumns = (hiddenColumnsSet, order) => {
    const orderedColumns = [];
    orderedColumns.push("actions");
    orderedColumns.push("idNumber");
    orderedColumns.push("hrn");
    order.map(category => {
      category.fields.map(field => {
        orderedColumns.push(field);
      });
    });
    orderedColumns.push("moreoptions");
    setColumnOrder(orderedColumns);
    setHiddenColumns([...hiddenColumnsSet]);
  };

  const staticFields = ["actions", "idNumber", "hrn", "moreoptions"];
  const defaultSelectedFields = [
    "recordId",
    "source",
    "suffixName",
    "givenName",
    "familyName",
    "addressLine",
    "city",
    "state",
    "postalCode",
    "birthDate",
    "gender",
    "phone",
    "email",
    "sourceName",
    "policyNum",
    "dependentCd",
    "divisionCd",
    "relationshipCd",
    "familyID",
    "memberID",
    "subscriberID",
    "carrierID",
    "accountID",
    "groupID",
    "origSysId",
    "medicaidRN",
    "coverageEndDate",
    "lastupdated",
    "lastUpdatedBySource",
    "household",
    "identifiers"
  ];
  const defaultColumnOrder = [
    {
      heading: "Record", // Record heading
      fields: ["source", "recordId"]
    },
    {
      heading: "Demographics", // demographic heading
      fields: ["birthDate", "deceasedDateTime", "gender"]
    },
    {
      heading: "Name", // Name heading
      fields: ["suffixName", "givenName", "familyName"]
    },
    {
      heading: "ID", // ID heading
      fields: [
        ...identifiersConfig.map(identifier => identifier.heading.toLowerCase())
      ]
    },
    {
      heading: "Address", // address heading
      fields: ["addressLine", "city", "postalCode", "state", "household"]
    },
    {
      heading: "Contact", // contact heading
      fields: ["phone", "email"]
    },
    {
      heading: "System", // system heading
      fields: ["sourceName", "lastupdated", "lastUpdatedBySource"]
    },
    {
      heading: "HealthCare", // healthcare heading
      fields: [
        "policyNum",
        "dependentCd",
        "divisionCd",
        "relationshipCd",
        "familyID",
        "memberID",
        "subscriberID",
        "carrierID",
        "accountID",
        "groupID",
        "origSysId",
        "medicaidRN",
        "coverageEndDate"
      ]
    },
    {
      heading: "Other Identifiers", // other identifiers heading
      fields: [
        "identifiers",
        "altID",
        "cdbXrefId",
        "compasMemberNumber",
        "employerAssignedId",
        "irisAccountNumber",
        "niceMemberId",
        "oxfordMemberId",
        "riverValleyMemberId",
        "rxClaimsMemberId",
        "rxClaimsSupplementalId",
        "scriptMedPatientId",
        "studentResourcesId",
        "ursulaId"
      ]
    }
  ];

  const onCompareClick = () => {
    if (localStorage.compare) {
      const compareList = JSON.parse(localStorage.compare);
      const size = Object.keys(compareList).length;
      compareList[size] = Array.from(recordComparisonList.entries());
      localStorage.setItem("compare", JSON.stringify(compareList));
    } else {
      localStorage.setItem(
        "compare",
        JSON.stringify({ 0: Array.from(recordComparisonList.entries()) })
      );
    }
  };

  const selectAllLinksHandler = () => {
    setIsLinkAllSelected(current => !current);
    let clonedMap = new Map();
    if (!isLinkAllSelected) {
      clonedMap = linkAllToggler(
        selectedRowsMap,
        primaryRecordsFiltered,
        preSelectedRowsMap,
        "link"
      );
    } else {
      clonedMap = linkAllToggler(
        selectedRowsMap,
        primaryRecordsFiltered,
        preSelectedRowsMap,
        null
      );
    }

    setActionCounts(actionCountsHandler(clonedMap));
    setSelectedRowsMap(clonedMap);
  };

  const onOvermergeClick = () => {
    setShowOptions(true);
  };

  const feedbackValidationSchema = Yup.object({
    identity: Yup.string().required("Please select an option."),
    reason: Yup.array().when("identity", {
      is: identity => {
        // If user selects "No" or "Not Sure" AND API says it's an Overmerge, reason is required
        if (
          (identity === "No" || identity === "Not Sure") &&
          isOvermergeByApi === true
        ) {
          return true;
        }
        // If user selects "Yes", reason is always required
        if (identity === "Yes") {
          return true;
        }
        // Otherwise (API says not overmerge or API failed), reason is not required
        return false;
      },
      then: schema => schema.min(1).required("Select reason."),
      otherwise: schema => schema.notRequired()
    }),
    otherReason: Yup.string().when("reason", {
      is: reason => reason && reason.includes("Others"),
      then: schema => schema.required("Please enter the other reason."),
      otherwise: schema => schema.notRequired()
    }),
    overmergeCase: Yup.string().when("identity", {
      is: "Yes",
      then: Yup.string().required("")
    }),
    otherOvermergeCase: Yup.string().when("overmergeCase", {
      is: overmergeCase => overmergeCase && overmergeCase === "Other",
      then: schema => schema.required("Please enter your category."),
      otherwise: schema => schema.notRequired()
    }),
    incidentId: Yup.string().notRequired()
  });

  const handleSubmit = async (values, { resetForm }) => {
    setIsSubmitting(true);
    try {
      const selectedreasons = values.reason;
      console.log("Selected reasons:", selectedreasons);
      console.log("Form identity value:", values.identity);
      const reasonToSend = values.reason.includes("Others")
        ? [...values.reason, values.otherReason]
        : values.reason;
      let overmergeCase = "None";
      if (values.identity === "Yes") {
        overmergeCase =
          values.overmergeCase === "Other"
            ? values.otherOvermergeCase
            : values.overmergeCase;
      }
      await processFeedbackSubmit(
        values.identity,
        reasonToSend,
        overmergeCase,
        values.incidentId
      );
    } catch (error) {
      console.error("Error during submission:", error);
    } finally {
      resetForm();
      setIsSubmitting(false);
      setShowOptions(false);
    }
  };

  const processFeedbackSubmit = async (
    value,
    reasonToSend,
    overmergeCase,
    incidentId
  ) => {
    let fhirBundle = focusedIdFhirBundleRef.current;
    if (!fhirBundle) {
      console.error("focusedIdFhirBundleRef.current is null or undefined");
      return;
    }
    let initReq = {};
    const feedback = feedbackApiReqGenerator(
      initReq,
      goldenId,
      user.role,
      userId,
      overmergeMessage,
      value,
      fhirBundle,
      reasonToSend,
      overmergeCase,
      incidentId
    );
    console.log("Feedback API Request:", feedback);
    if (Object.keys(feedback).length > 0) {
      await sendScores(feedback);
    } else {
      console.log("No Feedback to send.");
    }
    setShowOptions(false);
  };

  const extractScores = (valueStrings, reason) => {
    return valueStrings.map(valueString => {
      let scoreRecord = {};
      return overmergeScoresExtractor(
        scoreRecord,
        valueString,
        goldenId,
        user.role,
        userId
      );
    });
  };

  const callDiagnose = async goldenId => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_DIAGNOSE_API_DOMAIN}/diagnose?goldenId=${goldenId}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            flow: "aggregate"
          }
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.overmerge === true) {
          setOvermergeMessage(
            "AI Prediction- This Focus Identity is an Overmerge case"
          );
          setIsOvermergeByApi(true);
        } else {
          setOvermergeMessage(
            "AI Prediction- This Focus Identity is not an Overmerge case"
          );
          setIsOvermergeByApi(false);
        }
      } else {
        toast.error("Failed to fetch Model Prediction");
        setIsOvermergeByApi(null);
      }
    } catch (error) {
      console.error("Error at diagnose:", error);
      toast.error("Failed to fetch Model Prediction");
      setIsOvermergeByApi(null);
    }
  };

  const sendScores = async feedback => {
    try {
      const ScoresJson = JSON.stringify(feedback);
      const response = await fetch(`${process.env.REACT_APP_FEEDBACK_DOMAIN}`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          actor: user.role,
          updated_by: userId
        },
        body: ScoresJson
      });
      if (response.ok) {
        toast.info("Response sent successfully.");
      } else toast.error("Failed to send response.");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const primaryDatatableToggleBarUtil = () => {
    if (isNewQuarantine) {
      return null;
    }
    return (
      <div className={styles.scoreBar}>
        <div className={styles.FocusIdBar}>
          <AnchorButton
            to={{
              pathname: !is_review_queue_page
                ? `compare-records/${
                    localStorage.compare
                      ? Object.keys(JSON.parse(localStorage.compare)).length
                      : 0
                  }`
                : assignedRQId
                ? `${assignedRQId}/compare-records/${
                    localStorage.compare
                      ? Object.keys(JSON.parse(localStorage.compare)).length
                      : 0
                  }`
                : `${rqType}/compare-records/${
                    localStorage.compare
                      ? Object.keys(JSON.parse(localStorage.compare)).length
                      : 0
                  }`
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button onClick={onCompareClick}>
              Compare ({recordComparisonList.size})
            </Button>
          </AnchorButton>
          <LinkButton
            onClick={selectAllLinksHandler}
            icon="add"
            title="Link all"
            className={`${
              isLinkAllSelected
                ? styles.LinkAllButtonSelected
                : styles.LinkAllButton
            }`}
          />
          {isImdm && (
            <div className={styles.tooltip}>
              <Button onClick={onOvermergeClick} disabled={false}>
                Collision Feedback
              </Button>
              <span
                className={styles.tooltiptext}
                style={{ whiteSpace: "nowrap" }}
              >
                Review and provide feedback on AI Prediction for Collision
                Detection.
              </span>
            </div>
          )}
          {showOptions && (
            <Modal open={showOptions} onClose={() => setShowOptions(false)}>
              <Formik
                initialValues={{
                  identity: "",
                  reason: [],
                  otherReason: "",
                  overmergeCase: "",
                  otherOvermergeCase: "",
                  incidentId: ""
                }}
                validationSchema={feedbackValidationSchema}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={(values, actions) => {
                  handleSubmit(values, actions);
                }}
              >
                {({
                  values,
                  setFieldValue,
                  handleChange,
                  errors,
                  touched,
                  handleSubmit
                }) => {
                  return (
                    <Form
                      onSubmit={handleSubmit}
                      className={`${styles.modalContent} ${styles.feedbackForm}`}
                    >
                      <div className={styles.title}>
                        <p>
                          {" "}
                          Based on your analysis, would you classify this EID as
                          a co-mingling case?
                        </p>
                      </div>
                      <div className={styles.radioGroup}>
                        <label className={styles.feedbackRadioLabel}>
                          <Field
                            type="radio"
                            name="identity"
                            value="Yes"
                            checked={values.identity === "Yes"}
                            onChange={() => {
                              setFieldValue("identity", "Yes");
                              setFieldValue("reason", []);
                            }}
                            className={styles.feedbackRadioInput}
                          />
                          Yes
                        </label>
                        <label className={styles.feedbackRadioLabel}>
                          <Field
                            type="radio"
                            name="identity"
                            value="No"
                            checked={values.identity === "No"}
                            onChange={() => {
                              setFieldValue("identity", "No");
                              setFieldValue("reason", []);
                            }}
                            className={styles.feedbackRadioInput}
                          />
                          No
                        </label>
                        <label className={styles.feedbackRadioLabel}>
                          <Field
                            type="radio"
                            name="identity"
                            value="Not Sure"
                            checked={values.identity === "Not Sure"}
                            onChange={() => {
                              setFieldValue("identity", "Not Sure");
                              setFieldValue("reason", []);
                            }}
                            className={styles.feedbackRadioInput}
                          />
                          Not Sure
                        </label>
                        <ErrorMessage
                          name="identity"
                          component="div"
                          className={styles.error}
                        />
                      </div>
                      <div className={styles.feedbackFieldWrapper}>
                        <label htmlFor="reason">
                          <b>
                            {values.identity === "Yes"
                              ? "Conflicting Attributes"
                              : "Reason"}
                          </b>
                          {(values.identity === "Yes" ||
                            ((values.identity === "No" ||
                              values.identity === "Not Sure") &&
                              isOvermergeByApi === true)) && (
                            <span className={styles.feedbackRequired}> *</span>
                          )}
                          {!(
                            values.identity === "Yes" ||
                            ((values.identity === "No" ||
                              values.identity === "Not Sure") &&
                              isOvermergeByApi === true)
                          ) && (
                            <span className={styles.feedbackOptional}>
                              {" "}
                              (Optional)
                            </span>
                          )}
                        </label>
                        {(values.identity === "No" ||
                          values.identity === "Not Sure") &&
                          isOvermergeByApi === true && (
                            <div className={styles.feedbackWarning}>
                              ⚠️ Your assessment differs from the AI prediction.
                              Please provide a reason.
                            </div>
                          )}
                        <div className={styles.feedbackFieldInner}>
                          <Multiselect
                            options={
                              values.identity === "Yes"
                                ? [
                                    "Others",
                                    ...reason_list.filter(r => r !== "Others")
                                  ]
                                : values.identity === "No"
                                ? notOvermergeReasons
                                : [
                                    "Others",
                                    ...[
                                      ...reason_list,
                                      ...notOvermergeReasons
                                    ].filter(r => r !== "Others")
                                  ]
                            }
                            isObject={false}
                            placeholder={
                              values.identity === "Yes"
                                ? "Select Attributes"
                                : "Select Reason"
                            }
                            selectedValues={values.reason}
                            onSelect={selectedList =>
                              setFieldValue("reason", selectedList)
                            }
                            onRemove={selectedList =>
                              setFieldValue("reason", selectedList)
                            }
                            showArrow={true}
                            style={{
                              chips: {
                                background: "#1976d2",
                                color: "#ffffff",
                                fontSize: "14px"
                              },
                              searchBox: {
                                border: "1px solid #1976d2",
                                borderRadius: "4px",
                                backgroundColor: "#ffffff"
                              }
                            }}
                          />
                        </div>
                        <ErrorMessage
                          name="reason"
                          component="div"
                          className={styles.error}
                        />
                      </div>
                      {values.reason.includes("Others") && (
                        <div className={styles.feedbackFieldWrapper}>
                          <label htmlFor="otherReason">
                            <b>Enter Reason</b>
                            <span className={styles.feedbackRequired}> *</span>
                          </label>
                          <div className={styles.feedbackFieldInner}>
                            <Field name="otherReason">
                              {({ field }) => (
                                <textarea
                                  {...field}
                                  placeholder="Enter Reason Here"
                                  maxLength="250"
                                  rows="3"
                                  className={styles.feedbackTextarea}
                                />
                              )}
                            </Field>
                            <div className={styles.feedbackCharCount}>
                              {values.otherReason
                                ? values.otherReason.length
                                : 0}
                              /250
                            </div>
                          </div>
                          <ErrorMessage
                            name="otherReason"
                            component="div"
                            className={styles.error}
                          />
                        </div>
                      )}
                      {values.identity === "Yes" && (
                        <div className={styles.feedbackFieldWrapper}>
                          <label htmlFor="overmergeCase">
                            <b>Overmerge Category</b>
                            <span className={styles.feedbackRequired}> *</span>
                          </label>
                          <div className={styles.feedbackFieldInner}>
                            <Multiselect
                              options={overmergeCases}
                              isObject={false}
                              placeholder="Select Category"
                              singleSelect={true}
                              selectedValues={
                                values.overmergeCase
                                  ? [values.overmergeCase]
                                  : []
                              }
                              onSelect={selectedList => {
                                setFieldValue(
                                  "overmergeCase",
                                  selectedList[0] || ""
                                );
                              }}
                              onRemove={() => {
                                setFieldValue("overmergeCase", "");
                              }}
                              showArrow={true}
                              closeOnSelect={true}
                              avoidHighlightFirstOption={true}
                              style={{
                                chips: {
                                  background: "#1976d2",
                                  color: "#ffffff",
                                  fontSize: "14px"
                                },
                                searchBox: {
                                  border: "1px solid #1976d2",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  minHeight: "38px",
                                  backgroundColor: "#ffffff"
                                },
                                inputField: {
                                  cursor: "pointer"
                                }
                              }}
                            />
                          </div>
                          <ErrorMessage
                            name="overmergeCase"
                            component="div"
                            className={styles.error}
                          />
                        </div>
                      )}
                      {values.identity === "Yes" &&
                        values.overmergeCase === "Other" && (
                          <div className={styles.feedbackFieldWrapper}>
                            <label htmlFor="otherOvermergeCase">
                              <b>Specify Category</b>
                              <span className={styles.feedbackRequired}>
                                {" "}
                                *
                              </span>
                            </label>
                            <div className={styles.feedbackFieldInner}>
                              <input
                                type="text"
                                id="otherOvermergeCase"
                                name="otherOvermergeCase"
                                placeholder="Enter Category Here"
                                value={values.otherOvermergeCase || ""}
                                onChange={handleChange}
                                className={styles.feedbackInput}
                              />
                            </div>
                            <ErrorMessage
                              name="otherOvermergeCase"
                              component="div"
                              className={styles.error}
                            />
                          </div>
                        )}
                      <div className={styles.feedbackFieldWrapper}>
                        <label htmlFor="incidentId">
                          <b>
                            Incident ID / Worklist / Other{" "}
                            <span className={styles.feedbackOptional}>
                              (Optional)
                            </span>
                          </b>
                        </label>
                        <div className={styles.feedbackFieldInner}>
                          <Field
                            type="text"
                            name="incidentId"
                            placeholder="Enter Incident ID, Worklist, or NA"
                            maxLength="30"
                            className={styles.feedbackIncidentInput}
                          />
                        </div>
                        <ErrorMessage
                          name="incidentId"
                          component="div"
                          className={styles.error}
                        />
                      </div>
                      <div className={styles.feedbackNote}>
                        <p>
                          <strong>Note:</strong> Please provide your feedback
                          prior to resolving the EID.
                        </p>
                      </div>
                      <div className={styles.buttonGroup}>
                        <button
                          type="submit"
                          disabled={
                            isSubmitting ||
                            !values.identity ||
                            ((values.identity === "No" ||
                              values.identity === "Not Sure") &&
                              isOvermergeByApi === true &&
                              values.reason.length === 0) ||
                            (values.identity === "Yes" &&
                              (values.reason.length === 0 ||
                                !values.overmergeCase)) ||
                            (values.reason.includes("Others") &&
                              !values.otherReason) ||
                            (values.identity === "Yes" &&
                              values.overmergeCase === "Other" &&
                              !values.otherOvermergeCase)
                          }
                          className={styles.feedbackConfirmBtn}
                        >
                          Confirm
                        </button>
                        <button
                          type="button"
                          onClick={() => setShowOptions(false)}
                          className={styles.feedbackCancelBtn}
                        >
                          Cancel
                        </button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </Modal>
          )}
          {overmergeMessage && isImdm && (
            <span
              className={`${
                overmergeMessage ===
                "AI Prediction- This Focus Identity is an Overmerge case"
                  ? styles.overmergeMessage + " " + styles.red
                  : styles.overmergeMessage + " " + styles.green
              }`}
            >
              {overmergeMessage}
            </span>
          )}
        </div>
        <div className={styles.score}>
          <span className={styles.scoreToggle}>
            <span className={styles.scoreToggleButton}>
              <TogglingButton value={showScores} setState={setShowScores} />
            </span>
            <span className={styles.showScoresText}>
              {showScores ? "Hide " : "Show "}Scores
            </span>
            {showScores && (
              <>
                <span className={styles.thresholdText}>Threshold:</span>
                <span className={styles.thresholdValue}>{threshold}</span>
              </>
            )}
          </span>
          <span className={styles.highlightToggle}>
            <span className={styles.scoreToggleButton}>
              <TogglingButton value={highlightAll} setState={setHighlightAll} />
            </span>
            <span className={styles.showScoresText}>Highlight Fields</span>
          </span>

          <span>
            <ColumnSelector
              name="focusIdentity"
              columnsPrimary={columnsPrimary}
              staticFields={staticFields}
              defaultSelectedFields={defaultSelectedFields}
              defaultColumnOrder={defaultColumnOrder}
              onApply={shuffleColumns}
              popoverClasses={{ right: "-300%" }}
            />
          </span>
        </div>
      </div>
    );
  };

  const handleRecompute = goldenId => {
    setAggregateLoadingState(true);
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/stewardship/computeaggregate/${goldenId}`;
    fetch(url, {
      method: "POST",
      headers: {
        clientId: selectedClient.oid,
        "Content-Type": "application/json",
        userId: userId
      }
    })
      .then(handleResponse)
      .then(() => {
        setAggregateLoadingState(false);
        fetchLinkageHistory();
        fetchAggregate();
        toast.info(`Identity successfully recomputed.`);
      })
      .catch(error => {
        setAggregateLoadingState(false);
        toast.error(`Failed to recompute identity.`);
      });
  };

  const [isRepartitionModalOpen, setIsRepartitionModalOpen] = React.useState(
    false
  );

  const handleRepartition = () => {
    setIsRepartitionModalOpen(true);
  };
  //multiple birth button in summary
  const handleMultipleBirth = goldenId => {
    setAggregateLoadingState(true);
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/stewardship/multipleBirth/${goldenId}`;
    fetch(url, {
      method: "POST",
      headers: {
        clientId: selectedClient.oid,
        "Content-Type": "application/json",
        userId: userId
      }
    })
      .then(handleResponse)
      .then(() => {
        fetchFhirBundle(); // fetch match api call
        setAggregateLoadingState(false);
        fetchLinkageHistory();
        fetchAggregate();
        toast.info(`Identity successfully multipleBirth.`);
      })
      .catch(error => {
        setAggregateLoadingState(false);
        toast.error(`Failed to multiplebirth identity.`);
      });
  };

  const sendAggregateAuxDataRequest = (
    detailMap,
    aggregateEimpLastUpdated,
    goldenId
  ) => {
    const requestPayload = prepareAggregateAuxDataRequest(
      detailMap,
      aggregateEimpLastUpdated,
      goldenId,
      identity
    );
    setRecordListLoadingState(true);
    const config = {
      method: "PUT",
      body: JSON.stringify(requestPayload),
      credentials: "include",
      headers: {
        clientId: selectedClient.oid,
        "Content-Type": "application/json",
        userId: userId
      }
    };
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/stewardship/update/aggregateAuxData/${goldenId}`;
    // "/patient/stewardship/update/aggregateAuxData/{goldenId}"
    fetch(url, config)
      .then(handleResponse)
      .then(response => {
        toast.success("Auxiliary aggregate changes were applied successfully.");
        fetchFhirBundle(false, false, true);
        fetchLinkageHistory();
        fetchAggregate();
        setRecordListLoadingState(false);
      })
      .catch(e => {
        fetchFhirBundle(false, false, true);
        fetchLinkageHistory();
        fetchAggregate();
        setRecordListLoadingState(false);
        switch (e.status) {
          case 409:
            toast.error(
              "This version of the aggregate is out of date. Refresh the page and try again."
            );
            break;
          default:
            toast.error("Failed to update auxiliary aggregate details.");
        }
      });
  };

  const fhirSummaryUtil = () => {
    if (isNewQuarantine) {
      return null;
    }

    const roles = ["Global Admin", "Organization Admin", "Data Steward"];

    const hasRole = roles.includes(user.role);
    const hasImdmClient =
      selectedClient &&
      selectedClient.organization &&
      ["UHG", "IMDM"].includes(selectedClient.organization.name);
    const canRecompute = hasRole && hasImdmClient;
    return (
      <Loader loading={aggregateLoadingState}>
        <FHIRSummary
          id={goldenId}
          patientInfo={identity}
          primaryRecords={expandedPrimaryRecords}
          linkageHistory={linkageHistory}
          handleRecompute={() => handleRecompute(goldenId)}
          canRecompute={canRecompute}
          isInvisible={checkReadOnlyUser(user)}
          handleRepartition={() => handleRepartition(goldenId)}
          handleMultipleBirth={() => handleMultipleBirth(goldenId)}
          handleAggregateAuxDataRequest={detailMap => {
            sendAggregateAuxDataRequest(
              detailMap,
              aggregateEimpLastUpdated,
              goldenId
            );
          }}
          isImdm={isImdm}
        />
      </Loader>
    );
  };

  const primaryDatatableUtil = () => {
    return (
      <div>
        {recordListLoadingState ? (
          <div className={styles.loader}>
            <Spinner />
          </div>
        ) : (
          <DataTable
            columns={columnsPrimary}
            data={primaryRecords}
            hiddenColumns={hiddenColumns}
            columnOrder={columnOrder}
            hasFlexLayout={true}
            hasHover={false}
            isStripped={false}
            tooltipContent={toolTipContent}
            handleScoreString={scoreString => {
              setScoreString(scoreString);
              scoreStringModal();
              setScoreStringDialog(true);
            }}
            mergeIdentitySpecEnableDisableMap={
              mergeIdentitySpecEnableDisableMap
            }
            handleMergeIdentitySpec={id => {
              setMergeRelatedIdentity(id);
              setMergeIdspecsConfirmationDialog(true);
            }}
            getHeaderProps={() => ({
              style: {
                backgroundColor: "#eeeeee",
                borderBottom: "2px solid"
              }
            })}
            expandableData={expandedPrimaryRecords}
            recordHistoryData={recordHistoryList}
            isNewQuarantine={isNewQuarantine}
            expandDetails={expandDetails}
            quarantineRecordId={quar_recordId}
            quarantineSourceId={quar_sourceId}
            closeClick={collapseDetails}
            // maxWidth="1150px"
            showScores={showScores}
            quarantineRecordDetails={quarantineDemographics}
            getRowProps={row => {
              let background = "";
              if (selectedRowsMap.has(row.original.id)) {
                background = "#e0e0e0";
              }
              return {
                style: { backgroundColor: background }
              };
            }}
            changeRecorodOverrideStatus={(detailMap, record) => {
              setRecordOverrideDialogContent(detailMap);
              setRecordOverride(record);
              if (detailMap.reviewOverrideType !== "all") {
                setRecordOverrideDialog(
                  detailMap["Mark as"] !== "Replace" ||
                    detailMap["Mark as"] !== "New" ||
                    detailMap.overrideIconClicked
                );
              }
            }}
            goldenId={goldenId}
            primarySpecId={primarySpecId}
            nameToTypeMap={nameToTypeMap}
          />
        )}
        <br />
      </div>
    );
  };

  const secondaryDatatableUtil = () => {
    return (
      <div>
        {recordListLoadingState ? (
          <div className={styles.loader}>
            <Spinner />
          </div>
        ) : (
          <DataTable
            columns={columnsSecoundry}
            data={secondaryRecords}
            hiddenColumns={hiddenColumns}
            columnOrder={columnOrder}
            hasFlexLayout={true}
            hasHover={false}
            hasSearchBar={true}
            showRelatedIdsScores={showRelatedIdsScores}
            isStripped={false}
            tooltipContent={toolTipContent}
            handleScoreString={scoreString => {
              setScoreString(scoreString);
              scoreStringModal();
              setScoreStringDialog(true);
            }}
            mergeIdentitySpecEnableDisableMap={
              mergeIdentitySpecEnableDisableMap
            }
            handleMergeIdentitySpec={id => {
              setMergeRelatedIdentity(id);
              setMergeIdspecsConfirmationDialog(true);
            }}
            getHeaderProps={() => ({
              style: {
                backgroundColor: "#eeeeee",
                borderBottom: "2px solid"
              }
            })}
            expandableData={expandedSecondaryRecords}
            recordHistoryData={recordHistoryList}
            closeClick={collapseDetails}
            criteria={searchCriteria}
            onChange={setSearchCriteria}
            onSearch={fetchFhirBundle}
            options={searchOptions}
            isRelatedIdentitesSearch={isRelatedIdentitesSearch}
            isReviewQueueTable={is_review_queue_page}
            changeRecorodOverrideStatus={(detailMap, record) => {
              setRecordOverrideDialogContent(detailMap);
              setRecordOverride(record);
              if (detailMap.reviewOverrideType !== "all") {
                setRecordOverrideDialog(
                  detailMap["Mark as"] !== "Replace" ||
                    detailMap["Mark as"] !== "New" ||
                    detailMap.overrideIconClicked
                );
              }
            }}
            goldenId={goldenId}
            primarySpecId={primarySpecId}
            nameToTypeMap={nameToTypeMap}
          />
        )}
        <br />
      </div>
    );
  };

  const deleteRecordUtil = () => {
    return (
      selectedDeleteRecord && (
        <Modal
          open={deleteConfirmationDailog}
          onClose={() => setDeleteConfirmationDialog(false)}
        >
          <div className={styles.marginBottom}>
            <div>
              Are you sure you want to <b>{action}</b> this <i> record</i>
            </div>
            <div>
              <ResultCard>
                <ResultCard.Summary>
                  <div style={{ width: "10rem" }}>
                    <div className={styles.heading}> Record ID</div>
                    <div>{selectedDeleteRecord.original.sourceEntityId}</div>
                  </div>
                </ResultCard.Summary>
                <ResultCard.Details>
                  <FHIRPatient
                    patient={expandedPrimaryRecords.find(
                      record =>
                        `${record.id}+${record.meta.source}` ===
                        selectedDeleteRecord.original.id
                    )}
                    summary
                  />
                </ResultCard.Details>
              </ResultCard>
            </div>
            <div>
              from this <i>identity</i>?
            </div>
            <div>
              <ResultCard>
                <ResultCard.Summary>
                  <div style={{ width: "10rem" }}>
                    <div className={styles.heading}> HCM ID</div>
                    <div>{identity.id}</div>
                  </div>
                </ResultCard.Summary>
                <ResultCard.Details>
                  <FHIRPatient patient={identity} summary />
                </ResultCard.Details>
              </ResultCard>
            </div>
          </div>
          {action === "delete" ? (
            <Formik
              initialValues={{ deleteReason: "" }}
              onSubmit={deleteRecordHandler}
              validateOnChange={false}
              validationSchema={Yup.object().shape({
                deleteReason: Yup.string().required("Required")
              })}
            >
              {({ errors, handleChange, handleSubmit, values }) => (
                <form onSubmit={handleSubmit}>
                  <section className={styles.deleteSection}>
                    <DropDownList
                      className={styles.center}
                      errorText={errors.deleteReason}
                      id="deleteReason"
                      onChange={handleChange}
                      label={
                        <Label
                          className={styles.labelCenter}
                          error={Boolean(errors.deleteReason)}
                          htmlFor="deleteReason"
                        >
                          Reason For Deletion
                        </Label>
                      }
                      required
                      value={values.deleteReason}
                    >
                      <DropDownList.Item value="">
                        Select Reason for Deletion
                      </DropDownList.Item>
                      <DropDownList.Item value="source_data_causing_mismatches">
                        Source Data Causing Mismatches
                      </DropDownList.Item>
                      <DropDownList.Item value="data_processing_problem">
                        Data Processing Problem
                      </DropDownList.Item>
                      <DropDownList.Item value="client_requested_data_removal">
                        Client Requested Data Removal
                      </DropDownList.Item>
                      <DropDownList.Item value="other">Other</DropDownList.Item>
                    </DropDownList>
                  </section>
                  <ButtonList className={styles.center}>
                    <Button primary type="submit">
                      Confirm
                    </Button>
                    <Button onClick={() => setDeleteConfirmationDialog(false)}>
                      Cancel
                    </Button>
                  </ButtonList>
                </form>
              )}
            </Formik>
          ) : null}
        </Modal>
      )
    );
  };

  const compareRecordsUtil = () => {
    return (
      <Modal
        open={compareRecordsDialog}
        onClose={() => setCompareRecordsDialog(false)}
      >
        <span>
          You've already selected 5 records. Please uncheck some to select more
          records.
        </span>
        <div style={{ marginTop: "1rem" }}>
          <Button primary onClick={() => setCompareRecordsDialog(false)}>
            Okay
          </Button>
        </div>
      </Modal>
    );
  };

  const idSpecUtil = () => {
    return (
      <ConfirmationDialog
        confirmationDailog={confirmationDailog}
        setConfirmationDialog={setConfirmationDialog}
        actionCounts={actionCounts}
        bulkStewardHandler={bulkStewardHandler}
      />
    );
  };

  const idSpecBarUtil = () => {
    if (isNewQuarantine) {
      return null;
    }
    return recordListLoadingState ? (
      <div className={styles.loader}>
        <Spinner />
      </div>
    ) : (
      <Flex.Item span={12}>
        {!reviewLoading ? (
          <div className={styles.actionBar}>
            <div className={styles.actions}>
              {primarySpecId ? (
                <div>{`Actions (Changes to be applied to existing primary identity spec) : `}</div>
              ) : (
                <div>{`Actions : `}</div>
              )}
              <div>
                {actionCounts.includeToPrimary > 0 && (
                  <div>{`${actionCounts.includeToPrimary} record(s) to be included to Focus Identity`}</div>
                )}
                {actionCounts.excludeFromPrimary > 0 && (
                  <div>{`${actionCounts.excludeFromPrimary} record(s) to be excluded from Focus Identity`}</div>
                )}

                {actionCounts.excludeFromPrimary === 0 &&
                  actionCounts.includeToPrimary === 0 && (
                    <div>{`No record(s) selected to be included or excluded from Focus Identity`}</div>
                  )}
              </div>
            </div>

            {isIdPresentInDynamicRQ && (
              <div className={styles.dynamicRQNameBar}>
                Focus Identity belongs to Review Queue(s):
                {dynamicRQofId.IMDMNearMatchReviewQueue && (
                  <div className={styles.dynamicRQName}>
                    Possible Over Merge
                  </div>
                )}
                {dynamicRQofId.NearMissReviewQueue && (
                  <div className={styles.dynamicRQName}>Near Miss</div>
                )}
                {dynamicRQofId.TwinsReviewQueue && (
                  <div className={styles.dynamicRQName}>Twins</div>
                )}
                {dynamicRQofId.CollisionDetectionReviewQueue && (
                  <div className={styles.dynamicRQName}>
                    Collision Review Queue
                  </div>
                )}
              </div>
            )}

            <ButtonList
              style={{
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Button
                width="12rem"
                primary
                disabled={
                  !isPreSelectedRowsChanged(selectedRowsMap, preSelectedRowsMap)
                }
                onClick={() => {
                  setConfirmationDialog(true);
                }}
                isInvisible={checkReadOnlyUser(user)}
                isRestricted={isRestricted}
              >
                Apply Changes
              </Button>
              {!is_review_queue_page && (
                <Button
                  width="12rem"
                  disabled={isPreSelectedRowsChanged(
                    selectedRowsMap,
                    preSelectedRowsMap
                  )}
                  primary
                  onClick={() => setSelectedRowsMap(new Map())}
                  isInvisible={checkReadOnlyUser(user)}
                  isRestricted={isRestricted}
                >
                  Cancel
                </Button>
              )}
              {is_review_queue_page && (
                <Button
                  width="12rem"
                  disabled={isPreSelectedRowsChanged(
                    selectedRowsMap,
                    preSelectedRowsMap
                  )}
                  primary
                  onClick={() => skipReviewedHandler("Reviewed")}
                  isInvisible={checkReadOnlyUser(user)}
                  isRestricted={isRestricted}
                >
                  Review
                </Button>
              )}
              {isIdPresentInDynamicRQ && (
                <Button
                  width="12rem"
                  primary
                  onClick={() => setReviewConfirmDialog(true)}
                  isInvisible={checkReadOnlyUser(user)}
                  isRestricted={isRestricted}
                >
                  Review
                </Button>
              )}
              {is_review_queue_page && (
                <LinkButton onClick={() => skipReviewedHandler("Unassigned")}>
                  Skip
                </LinkButton>
              )}
              {assignedRQList.length !== 0 && (
                <Button
                  width="12rem"
                  onClick={() => setAssignRQDialog(true)}
                  isInvisible={checkReadOnlyUser(user)}
                  isRestricted={isRestricted}
                >
                  Escalate
                </Button>
              )}
              <Button
                width="12rem"
                disabled={recordComparisonList.size == 0}
                onClick={() => setForceMergeDialog(true)}
                isInvisible={checkReadOnlyUser(user)}
                isRestricted={isRestricted}
              >
                Force Merge ({recordComparisonList.size})
              </Button>
              <Button
                width="12rem"
                disabled={
                  recordComparisonList.filter(rc =>
                    primaryRecords.find(
                      pr =>
                        pr.recordId === rc.id && pr.source === rc.meta.source
                    )
                  ).size === 0
                }
                onClick={() => setMultipleRecordOverrideDialog(true)}
                isInvisible={checkReadOnlyUser(user)}
              >
                Override (
                {
                  recordComparisonList.filter(rc =>
                    primaryRecords.find(
                      pr =>
                        pr.recordId === rc.id && pr.source === rc.meta.source
                    )
                  ).size
                }
                )
              </Button>
            </ButtonList>
          </div>
        ) : (
          <div className={styles.loader}>
            <Spinner />
          </div>
        )}
      </Flex.Item>
    );
  };

  const reviewMSPageHandler = status => {
    if (isNewQuarantine) {
      return;
    }
    const org_name = user.preferences.selectedClient.organization.name;
    setReviewLoading(true);
    const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/rpc/reviewQueueItems/update/?client_id=${selectedClient.oid}&golden_id=${goldenId}&rq_status=${status}&category=dynamicReviewQueue&org_name=${org_name}`;
    fetch(url, {
      method: "PUT",
      headers: {
        user_id: userId
      }
    })
      .then(handleResponse)
      .then(() => {
        checkIdinDynamicRQExistence();
        setReviewLoading(false);
        setReviewConfirmDialog(false);
        // toast.info(`Focus Identity successfully marked reviewed.`);
      })
      .catch(error => {
        setReviewLoading(false);
        setReviewConfirmDialog(false);
        toast.error(`Failed to ${status} item in the review queue`);
      });
  };

  const handle204Response = response => {
    return response.status !== 204
      ? response.json().then(res => {
          if (response.ok) {
            return { ...res, status: response.status };
          } else {
            let error = { ...res, status: response.status };
            return Promise.reject(error);
          }
        })
      : Promise.resolve({
          ...response,
          status: response.status,
          isNoContent: true
        });
  };

  const checkIdinDynamicRQExistence = () => {
    // const urlLocal = `http://localhost:8000/api/review_queue_items/?client_oid=${selectedClient.oid}&category=dynamicReviewQueue&p_golden_id=${goldenId}`;
    const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/review_queue_items/?client_oid=${selectedClient.oid}&category=dynamicReviewQueue&p_golden_id=${goldenId}`;
    const mockUrl = `/IdinDynamicReviewQueue.json`;
    fetch(...fetchConfig(url, mockUrl))
      .then(handle204Response)
      .then(response => {
        if (!response.hasOwnProperty("isNoContent")) {
          const rq_items = response.results.filter(
            rqi =>
              rqi.status_type === "Unassigned" ||
              rqi.status_type === "Inprocess"
          );

          if (rq_items.length) {
            setIsIdPresentInDynamicRQ(true);
          } else {
            setIsIdPresentInDynamicRQ(false);
          }

          setDynamicRQofId({
            NearMatchReviewQueue: rq_items.some(
              rqi => rqi.rq_type === "NearMatchReviewQueue"
            ),
            IMDMNearMatchReviewQueue: rq_items.some(
              rqi => rqi.rq_type === "IMDMNearMatchReviewQueue"
            ),
            NearMissReviewQueue: rq_items.some(
              rqi => rqi.rq_type === "NearMissReviewQueue"
            ),
            TwinsReviewQueue: rq_items.some(
              rqi => rqi.rq_type === "TwinsReviewQueue"
            ),
            CollisionDetectionReviewQueue: rq_items.some(
              rqi => rqi.rq_type === "CollisionDetectionReviewQueue"
            )
          });
        } else setIsIdPresentInDynamicRQ(false);
      })
      .catch(e => {
        setReviewLoading(false);
        console.error("checkIdinDynamicRQExistence error: ", e);
      });
  };

  const fetchAlreadyExistingAssignedRQforFocusId = () => {
    setReviewLoading(true);
    // const urlLocal = `http://localhost:8000/api/review_queue_items/?client_oid=${selectedClient.oid}&category=assignedReviewQueue&p_golden_id=${goldenId}`;
    const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/review_queue_items/?client_oid=${selectedClient.oid}&category=assignedReviewQueue&p_golden_id=${goldenId}`;
    const mockUrl = `/alreadyExistingAssignedRQforFocusId.json`;
    fetch(...fetchConfig(url, mockUrl))
      .then(handle204Response)
      .then(response => {
        if (!response.hasOwnProperty("isNoContent")) {
          const assignedRQListOfFocusId = response.results.map(
            element => element.rq_name
          );
          setAlreadyAssignedRQOfFocusIdList(assignedRQListOfFocusId);
        } else setAlreadyAssignedRQOfFocusIdList([]);
        setReviewLoading(false);
      })
      .catch(error => {
        setReviewLoading(false);
        console.log("fetchAlreadyExistingAssignedRQforFocusId error: ", error);
      });
  };

  const checkAssignedRQExistence = () => {
    // const urlLocal = `http://localhost:8000/api/review_queues/?client_subscription__client_id=5&category=assignedReviewQueue`;

    const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/review_queues/?client_subscription__client_id=${clientIdNumber}&category=assignedReviewQueue`;
    const mockUrl = `/clientAssignedRQ.json`;
    fetch(...fetchConfig(url, mockUrl))
      .then(handle204Response)
      .then(response => {
        let clientAssignedRQNameList = [];
        if (!response.hasOwnProperty("isNoContent")) {
          clientAssignedRQNameList = response.results.map(
            assignedRQ => assignedRQ.name
          );
          setAssignedRQList(clientAssignedRQNameList);
          fetchAlreadyExistingAssignedRQforFocusId();
        } else {
          setAssignedRQList(clientAssignedRQNameList);
        }
      })
      .catch(e => {
        console.error("checkAssignedRQExistence error: ", e);
      });
  };

  const assignIdToAssignedRQs = () => {
    setAssignRQDialog(false);
    const tempToBeAssignedRQList = toBeAssignedRQList;
    setToBeAssignedRQList([]);

    // const urlLocal = `http://localhost:8000/api/review_queue_items/`;
    const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/review_queue_items/`;
    const mockUrl = `/FocusIdInsertionInAssignedRQ.json`;
    for (const assignedRQ of tempToBeAssignedRQList) {
      const data = {
        client_oid: selectedClient.oid,
        p_golden_id: goldenId,
        rq_name: assignedRQ,
        category: "assignedReviewQueue",
        rq_type: "UploadableReviewQueue"
      };
      const config = {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          userId: userId
        }
      };
      fetch(...fetchConfig(url, mockUrl, config))
        .then(handleResponse)
        .then(response => {
          toast.info(`Focus identity assigned to ${assignedRQ}`);
        })
        .catch(e => {
          console.error("assignIdToAssignedRQs error: " + e);
          e.hasOwnProperty("non_field_errors")
            ? toast.error(`Focus Identity already exists in ${assignedRQ}`)
            : toast.error(`Failed to assign Focus identity to ${assignedRQ}`);
        });
    }
    checkAssignedRQExistence();
  };

  const addIdinAssignRQ = rq_name => {
    let tempToBeAssignedRQList = [];
    tempToBeAssignedRQList.push(rq_name);
    setToBeAssignedRQList(tempToBeAssignedRQList);
  };

  const scoreStringModal = () => {
    return (
      <Modal
        open={scoreStringDialog}
        onClose={() => setScoreStringDialog(false)}
      >
        <div className={styles.bottomBanner}>
          <h2>Score String</h2>
          <br />
        </div>
        <div style={{ marginTop: "1rem" }}>
          <pre>{scoreString}</pre>
          <br />
          <ButtonList
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button onClick={() => navigator.clipboard.writeText(scoreString)}>
              Copy
            </Button>
            <Button onClick={() => setScoreStringDialog(false)}>Close</Button>
          </ButtonList>
        </div>
      </Modal>
    );
  };

  const reviewPopUpUtil = () => {
    return (
      <Modal
        open={reviewConfirmDialog}
        onClose={() => setReviewConfirmDialog(false)}
      >
        <div className={styles.bottomBanner}>
          <h2>Confirmation</h2>
        </div>

        <div style={{ marginTop: "1rem" }}>
          <div style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
            Review will resolve the identity present in all review queues. Press
            Confirm to continue.
          </div>
        </div>

        <div style={{ marginTop: "1rem" }}>
          <ButtonList
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button primary onClick={() => reviewMSPageHandler("Reviewed")}>
              Confirm
            </Button>
            <Button primary onClick={() => setReviewConfirmDialog(false)}>
              Cancel
            </Button>
          </ButtonList>
        </div>
      </Modal>
    );
  };

  const assignToRQUtil = () => {
    return (
      <Modal open={assignRQDialog} onClose={() => setAssignRQDialog(false)}>
        <div className={styles.bottomBanner}>
          <h2>Focus Identity:</h2>
          <div>{goldenId}</div>
        </div>

        <div>
          <div style={{ fontWeight: "bold" }}>Assigned:</div>
          {assignedRQList.map((item, index) => {
            return (
              <div key={index}>
                {alreadyAssignedRQOfFocusIdList.includes(item) && <p>{item}</p>}
              </div>
            );
          })}
        </div>

        <div style={{ marginTop: "1rem" }}>
          <div style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
            Escalate Focus Identity to Custom Review Queue:
          </div>
          <DropDownList onChange={e => addIdinAssignRQ(e.target.value)}>
            <DropDownList.Item value="">Select Review Queue</DropDownList.Item>
            {assignedRQList.map(item => {
              return (
                !alreadyAssignedRQOfFocusIdList.includes(item) && (
                  <DropDownList.Item key={item} value={item}>
                    {item}
                  </DropDownList.Item>
                )
              );
            })}
          </DropDownList>
        </div>

        <div style={{ marginTop: "1rem" }}>
          <ButtonList
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button primary onClick={() => assignIdToAssignedRQs()}>
              Confirm
            </Button>
            <Button primary onClick={() => setAssignRQDialog(false)}>
              Cancel
            </Button>
          </ButtonList>
        </div>
      </Modal>
    );
  };

  const SetForceMerge = () => {
    const sendForceMergeRequest = () => {
      setAggregateLoadingState(true);
      const forceMergeArray = Array.from(recordComparisonList.entries());
      const forceMergeRequest = forceMergeArray.map(record => ({
        correlationId: uuidv4(),
        sourceEntityId: record[1]["id"],
        sourceId: record[1]["meta"]["source"],
        surrogateId: record[1]["identifier"].filter(
          i =>
            i["extension"] &&
            i["extension"][0] &&
            i["extension"][0]["valueString"] == record[1]["meta"]["source"] &&
            i["extension"][1] &&
            i["extension"][1]["valueString"].includes(record[1]["id"])
        )[0]["value"]
      }));
      const forcePartitionRequests = {
        forcePartitionRequests: forceMergeRequest
      };

      const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/stewardship/force/clientId/${selectedClient.oid}/aggregate/${destinationGID}`;
      fetch(url, {
        method: "POST",
        body: JSON.stringify(forcePartitionRequests),
        headers: {
          user_id: userId,
          clientId: selectedClient.oid,
          "Content-Type": "application/json"
        }
      })
        .then(handleResponse)
        .then(response => {
          fetchFhirBundle();
          setAggregateLoadingState(false);
          fetchLinkageHistory();
          fetchAggregate();
          setRecordComparisonList(new Map());
          toast.info("FPR successfully sent for GID: " + destinationGID);
        })
        .catch(e => {
          setAggregateLoadingState(false);
          toast.error("Failed to send FPR for GID: " + destinationGID);
        });
    };

    const displayFPR = Array.from(
      recordComparisonList.entries()
    ).map(record => (
      <div>{record[1]["meta"]["source"] + "|" + record[1]["id"]}</div>
    ));

    const confirmForceMerge = () => {
      sendForceMergeRequest();
      setForceMergeDialog(false);
      setDestinationGID("");
    };

    const cancelForceMerge = () => {
      setForceMergeDialog(false);
      setDestinationGID("");
    };

    if (!isNewQuarantine) {
      return (
        <Modal
          open={forceMergeDialog}
          onClose={() => setForceMergeDialog(false)}
        >
          <div className={styles.bottomBanner}>
            <h2>Force Partitioning Request</h2>
            <div> Records to be merged:</div>
            <br></br>
            {displayFPR}
          </div>
          <div style={{ marginTop: "1rem" }}>
            <div style={{ marginTop: "1rem" }}>
              <div style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
                Enter the Destination Golden Id to merge selected records into:
              </div>
            </div>
            <ButtonList
              style={{
                display: "flex",
                justifyContent: "left"
              }}
            >
              <Button primary onClick={() => setDestinationGID(goldenId)}>
                Use Focus Identity GID
              </Button>
            </ButtonList>
          </div>
          <div style={{ marginTop: "1rem" }}>
            <div style={{ marginBottom: "0.5rem" }}>
              Or manually enter an existing golden Id:
            </div>
          </div>
          <form>
            <div className="input-group">
              <input
                type="text"
                value={destinationGID}
                onChange={e => setDestinationGID(e.target.value)}
              />
            </div>
          </form>
          <div style={{ marginTop: "1rem" }}>
            <ButtonList
              style={{
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Button
                disabled={destinationGID.length === 0}
                primary
                onClick={() => confirmForceMerge()}
              >
                Confirm
              </Button>
              <Button primary onClick={() => cancelForceMerge()}>
                Cancel
              </Button>
            </ButtonList>
          </div>
        </Modal>
      );
    }
  };

  // This function is used to override multiple records from the focus identity page. It is called when the "Override"
  // button is clicked while records are selected to be overridden. The function sends a POST request to the
  // /identity/v1/patient/stewardship/override endpoint in a JSON structure that contains a list of override requests.
  // The response is then handled and the user is notified of the success or failure of the override request.
  //
  // The purpose of this function is to allow the user to override multiple records at once, rather than having to
  // override each record individually in record details.
  //
  // TODO: add functionality to track where overridden records are moved to.
  // TODO: add ability to enter custom values for override.
  // TODO: add "incorrect" values to records that were selected, but not overridden.

  const SetRecordOverridesForGRExclusion = () => {
    return (
      <Modal
        open={multipleRecordOverrideDialog}
        onClose={() => setMultipleRecordOverrideDialog(false)}
      >
        <div className={styles.bottomBanner}>
          <h2>Override Records</h2>
          <br />
          <h4>
            Only selected primary records will be overridden. <br />
            Choose an attribute to override, action to perform, and value to
            override.
          </h4>
        </div>
        <Formik
          initialValues={{
            override_attribute: "",
            override_action: "",
            override_system: "",
            override_attrCode: "",
            override_correct_value: "",
            override_incorrect_value: "",
            override_code: "",
            selected_records: SelectedPrimaryRecords(
              recordComparisonList,
              primaryRecords
            )
          }}
          onSubmit={formValues => {
            // Save the form values and open the audit modal
            setPendingOverrideForm(formValues);
            setPendingOverrideValues(attributeValues);
            setAuditModalContext("multi");
            setIsAuditModalOpen(true); // open the audit modal
          }}
          validateOnChange={false}
          validationSchema={ValidationSchema(attributeValues)}
        >
          {({ errors, handleChange, handleSubmit, values }) => (
            <form onSubmit={handleSubmit}>
              <div className={styles.bulkOverride}>
                <div className={styles.dropDownDiv}>
                  <div className={styles.dropDownDivComponents}>
                    <DropDownList
                      id="override_action"
                      onChange={e => {
                        handleChange(e);
                        values.override_system = "";
                        values.override_attrCode = "";
                        values.override_attribute = "";
                        values.override_correct_value = "";
                        values.override_incorrect_value = "";
                        values.override_code = "";
                      }}
                      errorText={errors.override_action}
                      label={
                        <Label
                          htmlFor="override_action"
                          style={{ fontWeight: "bold" }}
                          error={Boolean(errors.override_action)}
                        >
                          Action
                        </Label>
                      }
                      required
                      value={values.override_action}
                    >
                      <DropDownList.Item value={""}>
                        {"Select Action"}
                      </DropDownList.Item>
                      {ActionDropDownValues.map(v => (
                        <DropDownList.Item value={v.value}>
                          {capitalize(v.displayName)}
                        </DropDownList.Item>
                      ))}
                    </DropDownList>
                  </div>
                  <div className={styles.dropDownDivComponents}>
                    <DropDownList
                      id="override_attribute"
                      onChange={e => {
                        handleChange(e);
                        setAttributeValues(
                          AttributeValues(
                            e.target.value,
                            values.selected_records
                          )
                        );
                        values.override_system = "";
                        values.override_attrCode = "";
                        values.override_correct_value = "";
                        values.override_incorrect_value = "";
                        values.override_code = "";
                      }}
                      errorText={errors.override_attribute}
                      label={
                        <Label
                          htmlFor="override_attribute"
                          style={{ fontWeight: "bold" }}
                          error={Boolean(errors.override_attribute)}
                        >
                          Attribute
                        </Label>
                      }
                      required
                      value={values.override_attribute}
                    >
                      <DropDownList.Item value={""}>
                        {"Select Attribute"}
                      </DropDownList.Item>
                      {values.override_action !== "" &&
                        AttributeDropDownValues(
                          values.override_action
                        ).map(v => (
                          <DropDownList.Item value={v.value}>
                            {capitalize(v.displayName)}
                          </DropDownList.Item>
                        ))}
                    </DropDownList>
                  </div>
                  {["identifier"].includes(values.override_attribute) && (
                    <div className={styles.dropDownDivComponents}>
                      <DropDownList
                        id="override_system"
                        onChange={e => {
                          handleChange(e);
                          values.override_code = "";
                          values.override_correct_value = "";
                          values.override_incorrect_value = "";
                        }}
                        errorText={errors.override_system}
                        label={
                          <Label
                            htmlFor="override_system"
                            style={{ fontWeight: "bold" }}
                            error={Boolean(errors.override_system)}
                          >
                            System
                          </Label>
                        }
                        required
                        value={values.override_system}
                      >
                        <DropDownList.Item value={""}>
                          {"Select System"}
                        </DropDownList.Item>
                        {values.override_attribute !== "" &&
                          IdentifierSystemDropDownValues(
                            attributeValues
                          ).map(v => (
                            <DropDownList.Item value={v}>{v}</DropDownList.Item>
                          ))}
                      </DropDownList>
                    </div>
                  )}
                  {["[No System]"].includes(values.override_system) && (
                    <div className={styles.dropDownDivComponents}>
                      <DropDownList
                        id="override_code"
                        onChange={e => {
                          handleChange(e);
                          values.override_correct_value = "";
                          values.override_incorrect_value = "";
                        }}
                        errorText={errors.override_code}
                        label={
                          <Label
                            htmlFor="override_code"
                            style={{ fontWeight: "bold" }}
                            error={Boolean(errors.override_code)}
                          >
                            Code
                          </Label>
                        }
                        required
                        value={values.override_code}
                      >
                        <DropDownList.Item value={""}>
                          {"Select Code"}
                        </DropDownList.Item>
                        {values.override_attribute !== "" &&
                          IdentifierCodeDropDownValues(
                            attributeValues
                          ).map(v => (
                            <DropDownList.Item value={v}>{v}</DropDownList.Item>
                          ))}
                      </DropDownList>
                    </div>
                  )}
                  {["phone", "email", "address", "name"].includes(
                    values.override_attribute
                  ) && (
                    <div className={styles.dropDownDivComponents}>
                      <DropDownList
                        id="override_attrCode"
                        onChange={handleChange}
                        errorText={errors.override_attrCode}
                        label={
                          <Label
                            htmlFor="override_attrCode"
                            style={{ fontWeight: "bold" }}
                            error={Boolean(errors.override_attrCode)}
                          >
                            AttrCode
                          </Label>
                        }
                        required
                        value={values.override_attrCode}
                      >
                        <DropDownList.Item value={""}>
                          {"Select AttrCode"}
                        </DropDownList.Item>
                        {values.override_attribute !== "" &&
                          AttrCodeDropDownValues(attributeValues).map(v => (
                            <DropDownList.Item value={v}>{v}</DropDownList.Item>
                          ))}
                      </DropDownList>
                    </div>
                  )}
                  <div className={styles.dropDownDivComponents}>
                    <DropDownList
                      className={styles.inputBox}
                      id="override_incorrect_value"
                      onChange={handleChange}
                      errorText={errors.override_incorrect_value}
                      label={
                        <Label
                          htmlFor="override_incorrect_value"
                          style={{ fontWeight: "bold" }}
                          error={Boolean(errors.override_incorrect_value)}
                        >
                          Value To Override
                        </Label>
                      }
                      required
                      value={values.override_incorrect_value}
                      disabled={
                        values.override_attribute.length === 0 ||
                        values.override_action.length === 0 ||
                        (!["birthDate", "gender"].includes(
                          values.override_attribute
                        ) &&
                          values.override_system.length === 0 &&
                          values.override_attrCode.length === 0) ||
                        (["identifier"].includes(values.override_attribute) &&
                          values.override_system === "[No System]" &&
                          values.override_code === "")
                      }
                    >
                      <DropDownList.Item value={""}>
                        {"Select Value To Override"}
                      </DropDownList.Item>
                      {values.override_attribute !== "" &&
                        CorrectAndIncorrectDropDownValues(
                          attributeValues,
                          values.override_attribute,
                          values.override_system,
                          values.override_attrCode,
                          values.override_code
                        ).map(v => (
                          <DropDownList.Item value={v}>{v}</DropDownList.Item>
                        ))}
                    </DropDownList>
                  </div>
                  {values.override_action === "replace" && (
                    <div className={styles.dropDownDivComponents}>
                      <DropDownList
                        className={styles.inputBox}
                        id="override_correct_value"
                        onChange={handleChange}
                        errorText={errors.override_correct_value}
                        label={
                          <Label
                            style={{ fontWeight: "bold" }}
                            htmlFor="override_correct_value"
                            error={Boolean(errors.override_correct_value)}
                          >
                            New Value
                          </Label>
                        }
                        required
                        value={values.override_correct_value}
                        disabled={
                          values.override_attribute.length === 0 ||
                          values.override_action !== "replace" ||
                          (!["birthDate", "gender"].includes(
                            values.override_attribute
                          ) &&
                            values.override_system.length === 0 &&
                            values.override_attrCode.length === 0) ||
                          (["identifier"].includes(values.override_attribute) &&
                            values.override_system === "[No System]" &&
                            values.override_code === "")
                        }
                      >
                        <DropDownList.Item value="">
                          {"Select New Value"}
                        </DropDownList.Item>
                        {values.override_attribute !== "" &&
                          CorrectAndIncorrectDropDownValues(
                            attributeValues,
                            values.override_attribute,
                            values.override_system,
                            values.override_attrCode,
                            values.override_code
                          ).map(v => (
                            <DropDownList.Item value={v}>{v}</DropDownList.Item>
                          ))}
                      </DropDownList>
                    </div>
                  )}
                </div>
                <div className={styles.summaryTable}>
                  <h3>Override Summary</h3>
                  {values.override_attribute !== "" &&
                  values.override_action !== "" ? (
                    <SummaryTable
                      selectedRecords={attributeValues}
                      action={values.override_action}
                      attribute={values.override_attribute}
                      correctValue={values.override_correct_value}
                      incorrectValue={values.override_incorrect_value}
                      system={values.override_system}
                      attrCode={values.override_attrCode}
                      code={values.override_code}
                    />
                  ) : (
                    <h4 style={{ marginTop: "1rem" }}>
                      Select all applicable fields to view a summary.
                    </h4>
                  )}
                </div>

                <div className={styles.bottomButtons}>
                  <div className={styles.overrideCount}>
                    <span>
                      {values.override_action !== "" &&
                        values.override_attribute !== "" && (
                          <RecordOverrideCountString
                            selectedRecords={attributeValues}
                            attribute={values.override_attribute}
                            system={values.override_system}
                            attrCode={values.override_attrCode}
                            action={values.override_action}
                            incorrectValue={values.override_incorrect_value}
                            code={values.override_code}
                          />
                        )}
                    </span>
                  </div>
                  <Button className={styles.button} primary type="submit">
                    Confirm
                  </Button>
                  <Button
                    onClick={() => setMultipleRecordOverrideDialog(false)}
                    className={styles.button}
                  >
                    Cancel
                  </Button>
                  <div>
                    <div>
                      {errors.undefined && (
                        <span className={styles.errorText}>
                          {errors.undefined}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </Modal>
    );
  };

  const SendOverrideRequestForGRExclusion = overrideRequestObject => {
    setRecordListLoadingState(true);
    const config = {
      method: "PUT",
      body: JSON.stringify({
        patients: overrideRequestObject.map(v => JSON.stringify(v, null, 0))
      }),
      credentials: "include",
      headers: {
        clientId: selectedClient.oid,
        sourceId: overrideRequestObject[0].meta.source,
        "Content-Type": "application/json",
        userId: userId
      }
    };

    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patientsource/override`;
    fetch(url, config)
      .then(handleResponse)
      .then(response => {
        toast.success("Record override operation was successful");
        setRecordComparisonList(new Map());
        fetchFhirBundle(false, false, true);
        fetchLinkageHistory();
        fetchAggregate();
        setRecordListLoadingState(false);
      })
      .catch(e => {
        setRecordComparisonList(new Map());
        fetchFhirBundle(false, false, true);
        fetchLinkageHistory();
        fetchAggregate();
        setRecordListLoadingState(false);
        toast.error("Record override operation failed");
      });
  };

  const focussedIdentityLabel = (secondaryIdLabel = false) => {
    return (
      <div className={styles.base}>
        <div className={styles.scoreBar}>
          <div className={styles.tableLabelDiv}>
            {!secondaryIdLabel && !isNewQuarantine && (
              <span className={styles.tableLabel}>Focus Identity Records</span>
            )}
            {secondaryIdLabel && (
              <span className={styles.tableLabel}>
                {isRelatedIdentitesSearch ? "Searched" : `Related`} Identities
                Records
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const relatedIdentitiesLabel = () => {
    return (
      <div className={styles.base}>
        <div className={styles.scoreBar}>
          <div className={styles.tableLabelDiv}>
            <span className={styles.tableLabel}>
              Related Identities' Records
            </span>
          </div>

          <div className={styles.score}>
            <span className={styles.scoreToggle}>
              <span className={styles.scoreToggleButton}>
                <TogglingButton
                  value={showRelatedIdsScores}
                  setState={setShowRelatedIdsScores}
                />
              </span>
              <span className={styles.showScoresText}>
                {showRelatedIdsScores ? "Hide " : "Show "}Related Identities
                Scores
              </span>
            </span>
          </div>
        </div>
      </div>
    );
  };

  const prepareOverrideRequest = (
    isForSummary,
    restoreAll,
    newOverrideField,
    newOverrideFieldData
  ) => {
    const finalPayload = JSON.parse(JSON.stringify(recordOverride));
    if (newOverrideField) {
      if (!finalPayload[newOverrideField]) {
        finalPayload[newOverrideField] = [];
      }
      finalPayload[newOverrideField].push(newOverrideFieldData);
    }
    const requestPayload = {
      resourceType: finalPayload.resourceType,
      id: finalPayload.id,
      meta: {
        ...finalPayload.meta,
        lastUpdated: ""
      }
    };
    if (!restoreAll) {
      for (var key in finalPayload) {
        if (
          typeof finalPayload[key] === "object" &&
          Array.isArray(finalPayload[key])
        ) {
          if (key === "extension") {
            // Build attribute-specific audit URL arrays
            const birthDateUrlsToInclude = [
              birthDateOverrideString,
              dobOverriddenByString,
              dobOverrideReasonString,
              dobOverrideTimestampString
            ];
            const genderUrlsToInclude = [
              genderOverrideString,
              genderOverriddenByString,
              genderOverrideReasonString,
              genderOverrideTimestampString
            ];
            const multipleBirthUrlsToInclude = [
              multipleBirthBooleanOverrideString,
              multipleBirthOverriddenByString,
              multipleBirthOverrideReasonString,
              multipleBirthOverrideTimestampString
            ];

            // Collect all relevant extensions for each attribute
            let overrideExtn = [];
            if (
              finalPayload.hasOwnProperty("birthDate") &&
              finalPayload[key].some(
                item => item.url === birthDateOverrideString
              )
            ) {
              overrideExtn = overrideExtn.concat(
                finalPayload[key].filter(item =>
                  birthDateUrlsToInclude.includes(item.url)
                )
              );
              requestPayload["birthDate"] = finalPayload["birthDate"];
            }
            if (
              finalPayload.hasOwnProperty("gender") &&
              finalPayload[key].some(item => item.url === genderOverrideString)
            ) {
              overrideExtn = overrideExtn.concat(
                finalPayload[key].filter(item =>
                  genderUrlsToInclude.includes(item.url)
                )
              );
              requestPayload["gender"] = finalPayload["gender"];
            }
            if (
              finalPayload.hasOwnProperty("multipleBirthBoolean") &&
              finalPayload[key].some(
                item => item.url === multipleBirthBooleanOverrideString
              )
            ) {
              overrideExtn = overrideExtn.concat(
                finalPayload[key].filter(item =>
                  multipleBirthUrlsToInclude.includes(item.url)
                )
              );
              requestPayload["multipleBirthBoolean"] =
                finalPayload["multipleBirthBoolean"];
            }

            // Remove duplicates if any
            overrideExtn = overrideExtn.filter(
              (item, index, self) =>
                index ===
                self.findIndex(
                  t =>
                    t.url === item.url &&
                    JSON.stringify(t) === JSON.stringify(item)
                )
            );

            if (overrideExtn.length > 0) {
              requestPayload.extension = overrideExtn;
            }
          } else {
            let overrideItem = finalPayload[key].map(item => {
              if (item.hasOwnProperty("extension")) {
                let isInactiveOrReplace = false;
                const urlsToInclude = [
                  genericOverrideURL,
                  overriddenByString,
                  overrideReasonString,
                  overrideTimestampString
                ];
                const overrideExtn = item.extension.filter(extn => {
                  if (extn.url === genericOverrideURL) {
                    if (Object.keys(item).length > 1) {
                      isInactiveOrReplace = true;
                    }
                  }
                  return urlsToInclude.includes(extn.url);
                });
                if (overrideExtn.length > 0) {
                  if (isInactiveOrReplace) return item;
                  else return { extension: overrideExtn };
                }
              }
            });
            overrideItem = overrideItem.filter(i => {
              return i !== undefined;
            });
            if (overrideItem.length > 0) {
              requestPayload[key] = overrideItem;
            }
          }
        }
      }
    }
    if (isForSummary) {
      return requestPayload;
    } else {
      setRecordOverrideDialog(false);
      sendOverrideRequet(requestPayload);
    }
  };

  const restoreSingleOverride = itemDetails => {
    const detailMap = itemDetails
      ? { ...itemDetails }
      : { ...recordOverrideDialogContent };
    const extValueType = getValueTypeByAttribute(detailMap.originalFieldName);
    let indexValue = 0;
    let foundValue = false;
    let restoreNewOverride = false;
    if (
      detailMap.originalFieldName === "birthDate" ||
      detailMap.originalFieldName === "gender" ||
      detailMap.originalFieldName === "multipleBirthBoolean"
    ) {
      const capitalizeValue = capitalize(
        detailMap.originalFieldName === "multipleBirthBoolean"
          ? "MultipleBirthIndicator"
          : detailMap.originalFieldName
      );
      recordOverride.extension.map((extn, index) => {
        let urlsToInclude = [];
        if (detailMap.originalFieldName === "birthDate") {
          urlsToInclude = [
            birthDateOverrideString,
            dobOverriddenByString,
            dobOverrideReasonString,
            dobOverrideTimestampString
          ];
        } else if (detailMap.originalFieldName === "gender") {
          urlsToInclude = [
            genderOverrideString,
            genderOverriddenByString,
            genderOverrideReasonString,
            genderOverrideTimestampString
          ];
        } else if (detailMap.originalFieldName === "multipleBirthBoolean") {
          urlsToInclude = [
            multipleBirthBooleanOverrideString,
            multipleBirthOverriddenByString,
            multipleBirthOverrideReasonString,
            multipleBirthOverrideTimestampString
          ];
        }
        if (urlsToInclude.includes(extn.url)) {
          // For the main override extension, restore the value and remove all related extensions
          if (extn.url === urlsToInclude[0]) {
            recordOverride[detailMap.originalFieldName] = extn[extValueType];
            // Remove all related extensions (main + audit) from recordOverride.extension
            recordOverride.extension = recordOverride.extension.filter(
              e => !urlsToInclude.includes(e.url)
            );
          }
        }
      });
    } else {
      recordOverride[detailMap.originalFieldName].map((item, index) => {
        if (item.hasOwnProperty("extension")) {
          // Include main override extension and all 3 audit extensions
          const urlsToInclude = [
            genericOverrideURL,
            overriddenByString,
            overrideReasonString,
            overrideTimestampString
          ];
          const overrideExtn = item.extension.filter(extn =>
            urlsToInclude.includes(extn.url)
          );
          // Find the main override extension for logic checks
          const mainOverrideExtn = overrideExtn.find(
            extn => extn.url === genericOverrideURL
          );
          if (mainOverrideExtn) {
            if (
              !detailMap.originalFieldData &&
              mainOverrideExtn.valueString === "new"
            ) {
              //To restore new overrride
              indexValue = index;
              restoreNewOverride = true;
            } else if (
              _.isEqual(
                mainOverrideExtn[extValueType],
                detailMap.originalFieldData
              )
            ) {
              indexValue = index;
              foundValue = true;
              return;
            }
          }
        }
      });
      if (foundValue) {
        recordOverride[detailMap.originalFieldName][indexValue] = JSON.parse(
          JSON.stringify(detailMap.originalFieldData)
        );
      }
      if (restoreNewOverride) {
        recordOverride[detailMap.originalFieldName].splice(indexValue, 1);
      }
    }
    if (!itemDetails) {
      prepareOverrideRequest();
    }
  };

  const handleConfirmOverride = auditDetails => {
    const detailMap = { ...recordOverrideDialogContent };
    //Single demographic fields
    if (
      detailMap.originalFieldName === "birthDate" ||
      detailMap.originalFieldName === "gender" ||
      detailMap.originalFieldName === "multipleBirthBoolean"
    ) {
      const capitalizeValue = capitalize(
        detailMap.originalFieldName === "multipleBirthBoolean"
          ? "MultipleBirthIndicator"
          : detailMap.originalFieldName
      );
      const overrideExtension = {
        url:
          "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override" +
          capitalizeValue +
          "/"
      };
      if (detailMap.originalFieldDataCopy) {
        overrideExtension[
          getValueTypeByAttribute(detailMap.originalFieldName)
        ] = detailMap.originalFieldDataCopy;
      } else {
        overrideExtension[getValueTypeByAttribute()] = "new";
      }
      if (!recordOverride.hasOwnProperty("extension")) {
        recordOverride.extension = [];
      }
      //create audit details
      const overrideAuditArray = createOverrideAuditExtension(
        detailMap.auditInfoList,
        detailMap.originalFieldName
      );
      recordOverride.extension.push(overrideExtension);
      overrideAuditArray.forEach(ext => {
        recordOverride["extension"].push(ext);
      });
      if (detailMap.originalFieldName === "birthDate") {
        recordOverride.birthDate = detailMap.originalFieldData;
      } else if (detailMap.originalFieldName === "gender") {
        recordOverride.gender = detailMap.originalFieldData;
      } else if (detailMap.originalFieldName === "multipleBirthBoolean") {
        recordOverride.multipleBirthBoolean = detailMap.originalFieldData;
      }
    } else {
      // non-single demoghrapic fields
      const overrideExtension = {
        url:
          "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override"
      };
      if (detailMap["Mark as"] === "New") {
        overrideExtension["valueString"] = "new";
      } else {
        overrideExtension[
          getValueTypeByAttribute(detailMap.originalFieldName)
        ] = JSON.parse(JSON.stringify(detailMap.originalFieldDataCopy));
      }

      if (detailMap["Mark as"] === "Inactive") {
        detailMap.originalFieldData.use = "old";
      } else if (detailMap["Mark as"] === "Invalid") {
        Object.keys(detailMap.originalFieldData).forEach(function(itm) {
          delete detailMap.originalFieldData[itm];
        });
      }

      if (!detailMap.originalFieldData.hasOwnProperty("extension")) {
        detailMap.originalFieldData.extension = [];
      }
      //create audit details
      const overrideAuditArray = createOverrideAuditExtension(
        auditDetails &&
          typeof auditDetails === "object" &&
          Object.keys(auditDetails).length > 0
          ? auditDetails
          : detailMap.auditInfoList,
        detailMap.originalFieldName
      );
      detailMap.originalFieldData.extension.push(overrideExtension);
      overrideAuditArray.forEach(ext => {
        detailMap.originalFieldData["extension"].push(ext);
      });
    }

    if (detailMap["Mark as"] === "New") {
      prepareOverrideRequest(
        false,
        false,
        detailMap.originalFieldName,
        detailMap.originalFieldData
      );
    } else {
      prepareOverrideRequest();
    }
  };

  const sendOverrideRequet = requestPayload => {
    setRecordListLoadingState(true);
    const config = {
      method: "PUT",
      body: JSON.stringify({
        patients: [JSON.stringify(requestPayload, null, 0)]
      }),
      credentials: "include",
      headers: {
        clientId: selectedClient.oid,
        sourceId: requestPayload.meta.source,
        "Content-Type": "application/json",
        userId: userId
      }
    };

    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patientsource/override`;
    fetch(url, config)
      .then(handleResponse)
      .then(response => {
        toast.success("Record Override operation was success");
        fetchFhirBundle(false, false, true);
        fetchLinkageHistory();
        fetchAggregate();
        setAttributeOverrides(defaultAttributeOverridesObject);
        setMultipleAttributeOverrideDialog(false);
      })
      .then(setRecordListLoadingState(false))
      .catch(e => {
        fetchFhirBundle(false, false, true);
        fetchLinkageHistory();
        fetchAggregate();
        setRecordListLoadingState(false);
        setAttributeOverrides(defaultAttributeOverridesObject);
        setMultipleAttributeOverrideDialog(false);
        toast.error("Record override operation failed");
      });
  };

  const overrideStatusChangeModal = () => {
    return (
      <Modal
        open={recordOverrideDialog}
        onClose={() => setRecordOverrideDialog(false)}
        style={{ minWidth: "50%" }}
      >
        {recordOverrideDialogContent.overrideIconClicked && (
          <div
            style={{
              textAlign: "center",
              color: "mediumvioletred",
              marginBottom: "1rem"
            }}
          >
            <Icon size="1.5rem" type="process" />
          </div>
        )}
        <h3 style={{ textAlign: "center" }}>
          {recordOverrideDialogContent.overrideIconClicked
            ? "Override Original Values"
            : recordOverrideDialogContent.Field + " Status Change"}
        </h3>
        {recordOverrideDialogContent.overrideIconClicked && (
          <>
            <br></br>
            <hr></hr>
          </>
        )}
        <br />
        <br />
        {!recordOverrideDialogContent.overrideIconClicked && (
          <span>
            {" "}
            You have choosen the following {
              recordOverrideDialogContent.Field
            }{" "}
            to be marked as{" "}
            <strong>{recordOverrideDialogContent["Mark as"]}.</strong>
          </span>
        )}
        <div>
          {recordOverrideDialogContent &&
            overrideOriginalTable(recordOverrideDialogContent)}
        </div>
        <br />
        <br />
        <div style={{ marginTop: "1rem" }}>
          {!recordOverrideDialogContent.overrideIconClicked && (
            <ButtonList
              style={{
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Button
                primary
                onClick={() => {
                  // Store pending override form state
                  setPendingOverrideForm(recordOverrideDialogContent);
                  setAuditModalContext("single");
                  setIsAuditModalOpen(true);
                }}
              >
                Confirm Changes
              </Button>
              <Button onClick={() => setRecordOverrideDialog(false)}>
                Cancel
              </Button>
            </ButtonList>
          )}
          {recordOverrideDialogContent.overrideIconClicked && (
            <ButtonList
              style={{
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Button onClick={() => setRecordOverrideDialog(false)}>
                Close
              </Button>
            </ButtonList>
          )}
        </div>
      </Modal>
    );
  };

  const handleRestoreSelection = (e, data, index) => {
    let list = [...recordOverrideRestoreList];
    const indexList = [...recordOverrideRestoreIndexList];
    if (e.target.checked) {
      indexList.push(data.Field + index);
      list.push(data);
    } else {
      const indexOfObject = indexList.findIndex(value => {
        return value === data.Field + index;
      });
      indexList.splice(indexOfObject, 1);
      list.splice(indexOfObject, 1);
    }
    setRecordOverrideRestoreIndexList(indexList);
    setRecordOverrideRestoreList(list);
  };

  const handleRestoreSelectedItems = () => {
    recordOverrideRestoreList.forEach(item => restoreSingleOverride(item));
    prepareOverrideRequest();
    closeSummaryModal();
  };

  const closeSummaryModal = () => {
    setRecordOverrideSummaryDialog(false);
    setRecordOverrideRestoreIndexList([]);
    setRecordOverrideRestoreList([]);
  };

  const multipleAttributeOverrideModal = MultipleAttributeOverrideModal(
    selectedMultipleAttributeOverrideRecord,
    expandedPrimaryRecords,
    attributeOverrides,
    setAttributeOverrides,
    multipleAttributeOverrideDialog,
    setMultipleAttributeOverrideDialog,
    setConfirmMultipleAttributeOverrideDialog,
    setRecordOverrideDialogContent,
    setRecordOverride,
    setRecordOverrideDialog,
    isNewQuarantine
  );

  const confirmMultipleAttributeOverrideModal = ConfirmMultipleAttributeOverrideModal(
    selectedMultipleAttributeOverrideRecord,
    expandedPrimaryRecords,
    attributeOverrides,
    confirmMultipleAttributeOverrideDialog,
    setConfirmMultipleAttributeOverrideDialog,
    sendOverrideRequet
  );

  const overrideOriginalTable = (tableData, index) => {
    if (isNewQuarantine) {
      return null;
    }
    return (
      <table className={styles.recOvrTable}>
        <tr>
          {tableData.overrideIconClicked &&
            tableData.reviewOverrideType === "all" && <th></th>}
          {Object.keys(tableData) &&
            Object.keys(tableData).map(recKey => {
              return recKey !== "Field" &&
                recKey !== "originalFieldName" &&
                recKey !== "originalFieldData" &&
                recKey !== "originalFieldDataCopy" &&
                recKey !== "reviewOverrideType" &&
                recKey !== "overrideIconClicked" &&
                recKey !== "id" ? (
                <th>
                  {recKey === "Mark as" && tableData.overrideIconClicked
                    ? "Status"
                    : recKey}
                </th>
              ) : (
                ""
              );
            })}
          {tableData.overrideIconClicked &&
            tableData.reviewOverrideType !== "all" && <th>Action</th>}
        </tr>
        <tr>
          {tableData.overrideIconClicked &&
            tableData.reviewOverrideType === "all" && (
              <td>
                <input
                  type="checkbox"
                  onChange={e => handleRestoreSelection(e, tableData, index)}
                />
              </td>
            )}
          {Object.keys(tableData) &&
            Object.keys(tableData).map(recKey => {
              return recKey !== "Field" &&
                recKey !== "originalFieldName" &&
                recKey !== "originalFieldData" &&
                recKey !== "originalFieldDataCopy" &&
                recKey !== "reviewOverrideType" &&
                recKey !== "overrideIconClicked" &&
                recKey !== "id" ? (
                <td
                  className={
                    recKey === "Mark as"
                      ? !tableData.overrideIconClicked
                        ? styles.markAsField
                        : styles.bold
                      : ""
                  }
                >
                  {" "}
                  {tableData[recKey]}{" "}
                </td>
              ) : (
                ""
              );
            })}
          {tableData.overrideIconClicked &&
            tableData.reviewOverrideType !== "all" && (
              <td>
                <Button primary onClick={() => restoreSingleOverride()}>
                  Restore
                </Button>
              </td>
            )}
        </tr>
      </table>
    );
  };

  const overrideSummaryAllDialog = () => {
    const identifiers =
      recordOverridePayload.identifier &&
      recordOverridePayload.identifier.filter(item => {
        const ext = item.extension.filter(
          ext =>
            ext.url === genericOverrideURL ||
            ext.url === overriddenByString ||
            ext.url === overrideReasonString ||
            ext.url === overrideTimestampString
        );
        const overrideExt = ext.find(e => e.url === genericOverrideURL);
        const overrideIdentifier = overrideExt
          ? overrideExt.valueIdentifier
          : undefined;
        return !(
          "type" in overrideIdentifier &&
          "coding" in overrideIdentifier.type &&
          overrideIdentifier.type.coding.length > 0 &&
          overrideIdentifier.type.coding[0].code === "COV"
        );
      });
    const covIdentifiers =
      recordOverridePayload.identifier &&
      recordOverridePayload.identifier.filter(item => {
        const ext = item.extension.filter(
          ext =>
            ext.url === genericOverrideURL ||
            ext.url === overriddenByString ||
            ext.url === overrideReasonString ||
            ext.url === overrideTimestampString
        );
        const overrideExt = ext.find(e => e.url === genericOverrideURL);
        const overrideIdentifier = overrideExt
          ? overrideExt.valueIdentifier
          : undefined;
        return (
          "type" in overrideIdentifier &&
          "coding" in overrideIdentifier.type &&
          overrideIdentifier.type.coding.some(c => c.code === "COV")
        );
      });
    const genderAuditUrls = [
      genderOverrideString,
      genderOverriddenByString,
      genderOverrideReasonString,
      genderOverrideTimestampString
    ];
    const genderMainPresent =
      recordOverridePayload.extension &&
      recordOverridePayload.extension.some(
        ({ url }) => url === genderOverrideString
      );

    const genderExt = genderMainPresent
      ? recordOverridePayload.extension.filter(({ url }) =>
          genderAuditUrls.includes(url)
        )
      : [];
    const birthDateAuditUrls = [
      birthDateOverrideString,
      dobOverriddenByString,
      dobOverrideReasonString,
      dobOverrideTimestampString
    ];
    const birthDateMainPresent =
      recordOverridePayload.extension &&
      recordOverridePayload.extension.some(
        ({ url }) => url === birthDateOverrideString
      );
    const birthDateExt = birthDateMainPresent
      ? recordOverridePayload.extension.filter(({ url }) =>
          birthDateAuditUrls.includes(url)
        )
      : [];
    const mutlipleBirthAuditUrls = [
      multipleBirthBooleanOverrideString,
      multipleBirthOverriddenByString,
      multipleBirthOverrideReasonString,
      multipleBirthOverrideTimestampString
    ];
    const mutlipleBirthMainPresent =
      recordOverridePayload.extension &&
      recordOverridePayload.extension.some(
        ({ url }) => url === multipleBirthBooleanOverrideString
      );

    const mutlipleBirthExt = mutlipleBirthMainPresent
      ? recordOverridePayload.extension.filter(({ url }) =>
          mutlipleBirthAuditUrls.includes(url)
        )
      : [];

    const summaryItems = {
      Name: recordOverridePayload.name,
      Address: recordOverridePayload.address,
      Gender: genderExt && genderExt.length > 0 ? genderExt : undefined,
      "Date of Birth":
        birthDateExt && birthDateExt.length > 0 ? birthDateExt : undefined,
      "Mutliple Birth":
        mutlipleBirthExt && mutlipleBirthExt.length > 0
          ? mutlipleBirthExt
          : undefined,
      "Contact Information": recordOverridePayload.telecom,
      Identifiers:
        identifiers && identifiers.length > 0 ? identifiers : undefined,
      "Coverage Identifiers":
        covIdentifiers && covIdentifiers.length > 0 ? covIdentifiers : undefined
    };
    return (
      <Modal
        open={recordOverrideSummaryDialog}
        onClose={() => setRecordOverrideSummaryDialog(false)}
        style={{ minWidth: "50%" }}
      >
        <div
          style={{
            textAlign: "center",
            color: "mediumvioletred",
            marginBottom: "1rem"
          }}
        >
          <Icon size="1.5rem" type="process" />
        </div>
        <h3 style={{ textAlign: "center" }}>Override Original Summary</h3>
        <br></br>
        <hr></hr>
        <br></br>
        <ButtonList
          style={{
            display: "flex"
          }}
        >
          <LinkButton
            onClick={() => handleRestoreSelectedItems()}
            disabled={recordOverrideRestoreList.length === 0}
          >
            Restore
          </LinkButton>
          <LinkButton
            onClick={() => {
              prepareOverrideRequest(false, true);
              closeSummaryModal();
            }}
          >
            Restore All
          </LinkButton>
        </ButtonList>
        <div
          style={{ maxHeight: "30rem", overflowY: "scroll", maxWidth: "70rem" }}
        >
          {Object.keys(summaryItems).map(demographicKey => {
            if (!summaryItems[demographicKey]) {
              return "";
            }
            return (
              <div>
                <div>
                  <br></br>
                  <br></br>
                  <h4>{demographicKey}</h4>
                </div>
                {["Gender", "Date of Birth", "Mutliple Birth"].includes(
                  demographicKey
                )
                  ? (() => {
                      let tableData;
                      switch (demographicKey) {
                        case "Gender":
                          tableData = overrideSummaryForGender(
                            recordOverridePayload.gender,
                            summaryItems[demographicKey], // pass the whole array
                            "all"
                          );
                          break;
                        case "Date of Birth":
                          tableData = overrideSummaryForBirthDate(
                            recordOverridePayload.birthDate,
                            summaryItems[demographicKey],
                            "all"
                          );
                          break;
                        case "Mutliple Birth":
                          tableData = overrideSummaryForMultipleBirth(
                            recordOverridePayload.multipleBirthBoolean,
                            summaryItems[demographicKey],
                            "all"
                          );
                          break;
                        default:
                          tableData = null;
                      }
                      const table = overrideOriginalTable(tableData, 0);
                      return (
                        <>
                          <br />
                          {table}
                        </>
                      );
                    })()
                  : summaryItems[demographicKey].map((item, index) => {
                      let tableData;
                      switch (demographicKey) {
                        case "Name":
                          tableData = overrideSummaryForName(item, "all");
                          break;
                        case "Address":
                          tableData = overrideSummaryForAddress(item, "all");
                          break;
                        case "Identifiers":
                          tableData = overrideSummaryForIdentifier(item, "all");
                          break;
                        case "Coverage Identifiers":
                          tableData = overrideSummaryForCoverageIdentifierImdm(
                            item,
                            "all"
                          );
                          break;
                        case "Contact Information":
                          tableData = overrideSummaryForTelecom(item, "all");
                          break;
                        default:
                          tableData = null;
                      }
                      const table = overrideOriginalTable(tableData, index);
                      return (
                        <>
                          <br />
                          {table}
                        </>
                      );
                    })}
              </div>
            );
          })}
        </div>
        <br />
        <div style={{ marginTop: "1rem" }}>
          <ButtonList
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button primary onClick={() => closeSummaryModal()}>
              Close
            </Button>
          </ButtonList>
        </div>
      </Modal>
    );
  };
  if (!is_review_queue_page) {
    return (
      <Layout>
        <FloatingSummaryButton
          goldenId={goldenId}
          eidInsightsData={eidInsightsData}
          insightsLoading={insightsLoading}
          insightsError={insightsError}
          fetchEidInsights={fetchEidInsights}
        />
        {isRepartitionModalOpen && <RepartitionModal />}
        <div onClick={() => setRowPopoverVisible(false)}>
          <Container>
            <Flex gutter={3}>
              {!isQuarantineView && (
                <Flex.Item span={12}>
                  <Breadcrumbs>
                    <Breadcrumbs.Item render={() => <Link to="/">Home</Link>} />
                    <Breadcrumbs.Item
                      render={() => (
                        <Link to="/search-identities-new">
                          Search Identities
                        </Link>
                      )}
                    />
                    <Breadcrumbs.Item last render={() => `View Identity`} />
                  </Breadcrumbs>
                </Flex.Item>
              )}

              <Flex.Item span={12}>
                <Content>
                  {!isNewQuarantine ? (
                    <h3>Record List</h3>
                  ) : (
                    <h3>Quarantine Record</h3>
                  )}
                </Content>
                {!OverlayType && !isQuarantineView && (
                  <div className={styles.alignRight}>
                    <LinkButton
                      className={styles.backButton}
                      onClick={history.goBack}
                      icon="arrow_wtail_bold_left"
                    >
                      Back to Search Identities Result
                    </LinkButton>
                  </div>
                )}
                {isQuarantineView && <br />}
                {fhirSummaryUtil()}
                {focussedIdentityLabel()}
                {ShowRestrictedDialog()}
                <div className={styles.base}>
                  {primaryDatatableToggleBarUtil()}
                  {primaryDatatableUtil()}
                  {idSpecBarUtil()}
                  {focussedIdentityLabel(true)}
                  {secondaryDatatableUtil()}
                </div>
              </Flex.Item>
            </Flex>
          </Container>
        </div>
        {deleteRecordUtil()}
        {idSpecUtil()}
        {compareRecordsUtil()}
        {assignToRQUtil()}
        {reviewPopUpUtil()}
        {SetForceMerge()}
        {SetRecordOverridesForGRExclusion()}
        {isAuditModalOpen && (
          <OverrideAuditInputModal
            isOpen={isAuditModalOpen}
            onCancel={() => setIsAuditModalOpen(false)}
            onSubmit={auditDetails => {
              setIsAuditModalOpen(false);
              setMultipleRecordOverrideDialog(false);
              if (auditModalContext === "multi") {
                const overrideRequestObject = PrepareOverrides(
                  pendingOverrideForm.override_attribute,
                  pendingOverrideForm.override_action,
                  pendingOverrideForm.override_system,
                  pendingOverrideForm.override_attrCode,
                  pendingOverrideForm.override_code,
                  pendingOverrideForm.override_correct_value,
                  pendingOverrideForm.override_incorrect_value,
                  pendingOverrideValues,
                  auditDetails
                );
                SendOverrideRequestForGRExclusion(overrideRequestObject);
                setPendingOverrideForm(null);
                setPendingOverrideValues(null);
              } else if (auditModalContext === "single") {
                handleConfirmOverride(auditDetails);
                setRecordOverrideDialog(false);
              }
              setAuditModalContext(null);
            }}
            pendingOverrideForm={pendingOverrideForm}
            pendingOverrideValues={pendingOverrideValues}
          />
        )}
        {overrideStatusChangeModal()}
        {overrideSummaryAllDialog()}
        {mergeIdspecConfirmationModal()}
        {scoreStringModal()}
        {multipleAttributeOverrideModal}
        {confirmMultipleAttributeOverrideModal}
      </Layout>
    );
  } else {
    return (
      <div>
        <FloatingSummaryButton
          goldenId={goldenId}
          eidInsightsData={eidInsightsData}
          insightsLoading={insightsLoading}
          insightsError={insightsError}
          fetchEidInsights={fetchEidInsights}
        />
        {isRepartitionModalOpen && <RepartitionModal />}
        <div onClick={() => setRowPopoverVisible(false)}>
          <Container>
            <Flex gutter={3}>
              <Flex.Item span={12}>
                {fhirSummaryUtil()}
                {focussedIdentityLabel()}
                <div className={styles.base}>
                  {primaryDatatableToggleBarUtil()}
                  {primaryDatatableUtil()}
                  {idSpecBarUtil()}
                  {focussedIdentityLabel(true)}
                  {secondaryDatatableUtil()}
                </div>
              </Flex.Item>
            </Flex>
          </Container>
        </div>

        {deleteRecordUtil()}
        {idSpecUtil()}
        {compareRecordsUtil()}
        {overrideStatusChangeModal()}
        {overrideSummaryAllDialog()}
        {mergeIdspecConfirmationModal()}
      </div>
    );
  }
};

export default SearchRecordTable;
